/* ABOUT SHELVES – KALLAX Konfigurator, erzeugt aus dem Prototyp v10.2.
   Produktdaten kommen aus sections/kallax-konfigurator.liquid (JSON in #kx-data). */
window.KallaxKonfigurator = function(){
  'use strict';

  /* ---------- Konfiguration: hier Preise, Varianten, Farben pflegen ---------- */
  const CFG = {
    doors: {
      P:{key:'P', name:'PLAIN',   finish:'nordisches Grün', price:24.90, variantId:'57718001107288', handle:'plain-kallax-tuer',                      base:'#8C9C86'},
      L:{key:'L', name:'LINEAR',  finish:'kreidiges Rosa',  price:24.90, variantId:'57802862657880', handle:'linear-geriffelte-tur-fur-kallax',         base:'#BE9D95', grooves:10, grooveW:0.22, grooveDark:'#7F544C', grooveLight:'#DCBEB6'},
      R:{key:'R', name:'REFLECT', finish:'Spiegeloptik',    price:29.90, variantId:'57961248391512', handle:'reflect-tur-mit-spiegeloptik-fur-kallax', base:'#DCE1E4'}
    },
    // ABOUT SHELVES Einsatz für KALLAX (Handle kallax-innenmodul, 24,90 €) – Träger der Soft-Close-Scharniere.
    // Der Einlegeboden ist EIN eigenes Produkt (5,90 €) und wird in der Menge n bestellt,
    // nicht als Paket. Ein Einsatz mit Böden ergibt deshalb ZWEI Line Items:
    // Einsatz ×1 + Einlegeboden ×n. Stand Shopify 10.09.2026.
    module: {
      name:'Einsatz für KALLAX', handle:'kallax-innenmodul',
      basePrice:24.90, baseVariantId:'58427966751064', defaultShelves:1,
      shelf: {
        name:'Einlegeboden für Tür-Einsatz, passend für KALLAX',
        handle:'zusatzlicher-einlegeboden-fur-kallax-innenmodul',
        price:5.90, variantId:'58428235678040'
      }
    },
    // Griffe – alle Varianten und Preise aus dem Shop (10.09.2026).
    // „ohne" ist kein Produkt: keine Variante, kein Preis, kein Line Item.
    // w = Profillänge in cm, wird so auch gezeichnet.
    // short = Kachelüberschrift, group = Unterzeile (weiches Trennzeichen für schmale Displays),
    // label = Klartext für Bild, Link und Warenkorb-Text, title = Produktname wie in Shopify.
    handles: {
      ohne:   {key:'ohne',   short:'Ohne Griff', group:'',                 label:'ohne Griff',                   title:null,
               kind:'none', price:0,     variantId:null,             col:null,      w:0},
      weiss:  {key:'weiss',  short:'Weiß',       group:'Kanten­griff', label:'Kantengriff Weiß',            title:'versteckter Möbelgriff aus Aluminium – 20 cm, Weiß',
               kind:'edge', price:10.90, variantId:'48039378518360', col:'#F2F0EC', w:20,   handle:'versteckter-mobelgriff-20cm-weiss'},
      schwarz:{key:'schwarz',short:'Schwarz',    group:'Kanten­griff', label:'Kantengriff Schwarz matt',    title:'Versteckter Kantengriff 20 cm – Schwarz matt',
               kind:'edge', price:15.90, variantId:'54347284709720', col:'#2A2A28', w:20,   handle:'versteckter-mobelgriff-20cm-schwarz'},
      spiegel:{key:'spiegel',short:'Spiegel',    group:'Kanten­griff', label:'Kantengriff spiegelnde Optik',title:'Kantengriff 135 mm – spiegelnde Optik',
               kind:'edge', price:12.90, variantId:'58429237100888', col:'mirror',  w:13.5, handle:'kantengriff-70-mm-chrom-poliert'},
      knopf:  {key:'knopf',  short:'Knopf',      group:'Möbel­knopf',  label:'Möbelknopf 30 mm',            title:'Möbelknopf 30mm, schwarz',
               kind:'knob', price:9.90,  variantId:'54347341398360', col:'#2A2A28', w:0,    handle:'mobelknopf-30mm-schwarz'}
    },
    korpus: {
      weiss:{name:'Weiß', base:'#F1EFEA'},
      schwarzbraun:{name:'Schwarzbraun', base:'#3B2F2A'},
      eiche:{name:'Eiche', base:'#CBB08C'}
    },
    // Alle KALLAX-Größen laut IKEA Deutschland (09/2026); a×b = Fächer, nicht-quadratische stehen hochkant oder quer
    sizes: [
      {id:'1x1', a:1, b:1}, {id:'1x2', a:1, b:2}, {id:'1x3', a:1, b:3}, {id:'1x4', a:1, b:4},
      {id:'2x2', a:2, b:2}, {id:'2x3', a:2, b:3}, {id:'2x4', a:2, b:4}, {id:'3x4', a:3, b:4},
      {id:'4x4', a:4, b:4}, {id:'5x5', a:5, b:5}
    ],
    // Nur die Ansicht von rechts wird gezeigt; front/left bleiben für die Render-Pipeline definiert.
    view:'right',
    views: {
      left: {kx:-0.42, ky:-0.30, label:'Von links'},
      front:{kx:0,     ky:0,     label:'Frontal'},
      right:{kx: 0.42, ky:-0.30, label:'Von rechts'}
    },
    // Geometrie in cm. Korpus aus IKEA-Außenmaßen abgeleitet (Fach 33,5; Zwischenwand 1,5; Außenwand 4,25 seitlich / 4,0 oben+unten; Tiefe 39).
    // Einsatz/Innenmodul = zwei Seitenwände + Rückwand (oben und unten bleibt der KALLAX-Korpus sichtbar). Tür/Einsatz-Maße sind Platzhalter bis Datenblatt.
    geo: { s:33.5, tIn:1.5, tSide:4.25, tTop:4.0, D:39, doorW:33, doorT:1.8, doorIn:0.35, gap:0.25, insT:1.6, insD:37, shelfT:1.6, handleW:20 },
    moduleColor:'#F5F3EF',
    dRange:[-34, 39],
    // Speichern/Teilen/Wiederkehr
    storageKey:'as_kallax_config_v1',   // localStorage-Schlüssel
    storageMaxAgeDays:60,               // ältere Konfigurationen werden nicht mehr angeboten
    shareTitle:'Mein KALLAX von ABOUT SHELVES',
    brand:'ABOUT SHELVES', domain:'aboutshelves.com',
    currency:'EUR', locale:'de-DE',
    defaultDoor:'L', defaultHandle:'weiss', defaultSize:'2x2', defaultKorpus:'weiss', defaultScene:'kids',
    routes:{ cart:'/cart', cartAdd:'/cart/add.js', cartUpdate:'/cart/update.js' },

    debugTracking:true                  // im Shop auf false: dann nur dataLayer + CustomEvent, keine Konsole
  };
  /* ---------- Werte aus Liquid: Variant-IDs, Preise, Titel, Routen ----------
     Fehlt ein Produkt im Theme, bleibt der Vorgabewert aus CFG stehen und der
     Warenkorb weigert sich spaeter mit einer klaren Meldung. */
  const DATA = (function(){
    const el = document.getElementById('kx-data');
    if(!el) return {};
    try{ return JSON.parse(el.textContent); }catch(e){ return {}; }
  })();
  (function applyData(){
    const num = v => (typeof v === 'number' && isFinite(v)) ? v : null;
    const str = v => (typeof v === 'string' && v.length) ? v : null;
    // Eine Variant-ID muss eine echte Zahl sein. Ist ein Produkt im Online-Store nicht
    // freigegeben, liefert Liquid leere Werte - dann bleibt der Vorgabewert aus CFG stehen,
    // statt Preis 0 anzuzeigen. Die Meldung sagt, welches Produkt fehlt.
    const vid = v => (typeof v === 'string' && /^[0-9]+$/.test(v)) ? v : null;
    const fehlt = [];
    const D = DATA;
    if(D.doors) for(const k in D.doors){ const s = D.doors[k], d = CFG.doors[k]; if(!d || !s) continue;
      if(!vid(s.variantId)){ fehlt.push('Tuer ' + k); continue; }
      if(str(s.variantId)) d.variantId = s.variantId;
      if(num(s.price) !== null) d.price = s.price;
      if(str(s.title)) d.title = s.title;
      if(str(s.handle)) d.handle = s.handle; }
    if(D.module){ const m = D.module;
      if(vid(m.baseVariantId)){
        CFG.module.baseVariantId = m.baseVariantId;
        if(num(m.basePrice) !== null) CFG.module.basePrice = m.basePrice;
        if(str(m.name)) CFG.module.name = m.name;
      } else fehlt.push('Einsatz fuer KALLAX');
      if(m.shelf && CFG.module.shelf){ const s = m.shelf, p = CFG.module.shelf;
        if(vid(s.variantId)){
          p.variantId = s.variantId;
          if(num(s.price) !== null) p.price = s.price;
          if(str(s.name)) p.name = s.name;
        } else fehlt.push('Einlegeboden'); } }
    if(D.handles) for(const k in D.handles){ const s = D.handles[k], h = CFG.handles[k]; if(!h || !s) continue;
      if(!vid(s.variantId)){ fehlt.push('Griff ' + k); continue; }
      h.variantId = s.variantId;
      if(num(s.price) !== null) h.price = s.price;
      if(str(s.title)) h.title = s.title; }
    if(D.defaults){
      if(CFG.doors[D.defaults.door]) CFG.defaultDoor = D.defaults.door;
      if(num(D.defaults.shelves) !== null) CFG.module.defaultShelves = D.defaults.shelves;
      if(CFG.handles[D.defaults.handle]) CFG.defaultHandle = D.defaults.handle;
      if(CFG.sizes.some(z => z.id === D.defaults.size)) CFG.defaultSize = D.defaults.size;
      if(CFG.korpus[D.defaults.korpus]) CFG.defaultKorpus = D.defaults.korpus;
      if(['kids','living','office','empty'].indexOf(D.defaults.scene) >= 0) CFG.defaultScene = D.defaults.scene;
    }
    if(typeof D.debugTracking === 'boolean') CFG.debugTracking = D.debugTracking;
    if(str(D.currency)) CFG.currency = D.currency;
    if(str(D.locale)) CFG.locale = D.locale;
    if(str(D.brand)) CFG.brand = D.brand;
    if(str(D.domain)) CFG.domain = D.domain;
    if(D.routes) Object.assign(CFG.routes, D.routes);
    if(fehlt.length && window.console) console.warn('[kallax] Nicht im Online-Store freigegeben, es gilt der Vorgabewert:', fehlt.join(', '));
  })();

  const shelfUnit = () => CFG.module.shelf || null;
  const modulePrice = n => CFG.module.basePrice + (n > 0 && shelfUnit() ? n * shelfUnit().price : 0);
  const INTERIOR_OPTIONS = [{module:false,shelves:1},{module:true,shelves:0},{module:true,shelves:1},{module:true,shelves:2},{module:true,shelves:3}];

  /* ---------- Zustand ---------- */
  // cube: { door:'P'|'L'|'R'|null, interior:null | {module, shelves} }  – interior = Ausnahme vom globalen Standard
  const state = {
    size:CFG.defaultSize, orient:'h', korpus:CFG.defaultKorpus, open:false, mode:'standalone', scene:CFG.defaultScene,
    cubes:[], brushDoor:CFG.defaultDoor,
    interior:{module:true, shelves:CFG.module.defaultShelves},
    handle:CFG.defaultHandle,
    // Umfang je Abschnitt: 'all' = Standard für alle Fächer, 'single' = Pinsel für einzelne Fächer.
    // Zurück auf 'all' ändert nichts, bis wirklich eine Option gewählt wird (sonst wäre ein Fehltipp teuer).
    interiorScope:'all', handleScope:'all',
    layer:'door', excBrush:{module:true, shelves:2}, excHandle:'schwarz', openBefore:false,
    history:[], flash:new Map(), setupOpen:true, touched:{size:false,korpus:false}
  };
  function eff(c){ return c.door ? (c.interior || state.interior) : null; }
  function effHandle(c){ return c.door ? (c.handle || state.handle) : null; }
  // Start: leeres Regal – der Kunde malt seine Türen selbst
  function emptyCube(){ return {door:null, interior:null, handle:null}; }
  function seed(){ const g = grid(), n = g.cols*g.rows; state.cubes = Array.from({length:n}, emptyCube); }
  function grid(){
    const sz = CFG.sizes.find(g=>g.id===state.size);
    const quer = sz.a!==sz.b && state.orient==='q';
    return { id:sz.id, a:sz.a, b:sz.b, square:sz.a===sz.b, cols: quer ? sz.b : sz.a, rows: quer ? sz.a : sz.b,
             label:`${sz.a}×${sz.b}` + (sz.a===sz.b ? '' : (quer ? ' quer' : ' hochkant')) };
  }

  /* ---------- URL-State: nur semantische Kürzel, nie Variant-IDs ----------
     Aufbau:  #v=1&g=4x4&r=q&k=s&o=1&m=p&s=l&i=K0&h=b&c=L4PK0b2O10
     - Standardwerte werden weggelassen, „g" und „c" sind immer da.
     - c = ein Token je Fach, mit Lauflängenkodierung: Token + Anzahl (>1).
       Token = Tür (O|P|L|R) + optional Innenleben (T|K0..K2) + optional Griff (n|w|b|m|k).
       Eindeutig, weil nach „K" genau eine Ziffer kommt und alle folgenden Ziffern die Wiederholung sind.
     - Variant-IDs stehen nie im Link; die Auflösung Kürzel → Variante passiert zur Laufzeit aus CFG
       (im Shop aus Liquid). Alte Links überleben damit Produkt- und Preisänderungen.
     - Unbekannte Kürzel führen nie zum Absturz: Fallback auf Standard + Hinweiszeile. */
  const KK={weiss:'w',schwarzbraun:'s',eiche:'e'}, KKR={w:'weiss',s:'schwarzbraun',e:'eiche'};
  const SK={kids:'k',living:'l',office:'o',empty:'x'}, SKR={k:'kids',l:'living',o:'office',x:'empty'};
  const HK={ohne:'n',weiss:'w',schwarz:'b',spiegel:'m',knopf:'k'}, HKR={n:'ohne',w:'weiss',b:'schwarz',m:'spiegel',k:'knopf'};
  const SCENES=['kids','living','office','empty'];

  const encInt = it => it.module ? 'K'+it.shelves : 'T';
  function parseInterior(s){
    if(!s) return null;
    if(s[0]==='T') return {module:false, shelves:CFG.module.defaultShelves};
    if(s[0]==='K'){ const v = parseInt(s[1],10); if(v>=0 && v<=3) return {module:true, shelves:v}; }
    return null;
  }
  const isDefaultInt = it => it.module && it.shelves===CFG.module.defaultShelves;

  function encodeCubes(){
    const tok = c => !c.door ? 'O' : c.door + (c.interior ? encInt(c.interior) : '') + (c.handle ? HK[c.handle] : '');
    let out='', prev=null, n=0;
    const flush = () => { if(prev!==null) out += prev + (n>1 ? n : ''); };
    for(const c of state.cubes){ const t = tok(c); if(t===prev){ n++; } else { flush(); prev=t; n=1; } }
    flush();
    return out;
  }
  function decodeCubes(str, n, warn){
    const cubes = [];
    // Legacy v9: Punkte als Trenner, „_" vor dem Griff – beides einfach entfernen, der Parser kommt damit klar.
    const s = String(str||'').replace(/[._]/g,'');
    let i = 0, guard = 0;
    while(i < s.length && cubes.length < n && guard++ < 5000){
      const d = s[i++];
      let door = null;
      if(d==='O') door = null;
      else if(CFG.doors[d]) door = d;
      else { warn.bad = true; door = null; }
      let interior = null, handle = null;
      if(door){
        if(s[i]==='T'){ interior = parseInterior('T'); i++; }
        else if(s[i]==='K'){ const it = parseInterior(s.slice(i,i+2)); if(it) interior = it; else warn.bad = true; i += 2; }
        const hc = s[i];
        if(hc && hc>='a' && hc<='z'){ const key = HKR[hc]; if(key && CFG.handles[key]) handle = key; else warn.bad = true; i++; }
      }
      let cnt = '';
      while(i < s.length && s[i]>='0' && s[i]<='9') cnt += s[i++];
      const rep = cnt ? Math.min(n, Math.max(1, parseInt(cnt,10))) : 1;
      for(let k=0;k<rep && cubes.length<n;k++) cubes.push({door, interior: interior?{...interior}:null, handle});
    }
    if(s && !cubes.length) warn.bad = true;
    while(cubes.length < n) cubes.push(emptyCube());
    return cubes;
  }
  function encode(){
    const p = ['v=1', 'g='+state.size];
    if(state.orient!=='h') p.push('r=q');
    if(state.korpus!=='weiss') p.push('k='+KK[state.korpus]);
    if(state.open) p.push('o=1');
    if(state.mode!=='standalone') p.push('m=p');
    if(state.scene!=='kids') p.push('s='+SK[state.scene]);
    if(!isDefaultInt(state.interior)) p.push('i='+encInt(state.interior));
    if(state.handle!=='weiss') p.push('h='+HK[state.handle]);
    p.push('c='+encodeCubes());
    return p.join('&');
  }
  function decode(hash){
    const warn = {bad:false};
    const p = new URLSearchParams(String(hash||'').replace(/^#/,''));
    if(!p.get('g')) return {ok:false, warn};
    const g = p.get('g');
    if(CFG.sizes.some(z=>z.id===g)) state.size = g; else warn.bad = true;
    state.orient = p.get('r')==='q' ? 'q' : 'h';
    const k = p.get('k'); state.korpus = 'weiss';
    if(k){ const kk = KKR[k] || (CFG.korpus[k] ? k : null); if(kk) state.korpus = kk; else warn.bad = true; }
    state.open = p.get('o')==='1';
    const m = p.get('m'); state.mode = (m==='p' || m==='pdp') ? 'pdp' : 'standalone';
    const sc = p.get('s'); state.scene = 'kids';
    if(sc){ const ss = SKR[sc] || (SCENES.includes(sc) ? sc : null); if(ss) state.scene = ss; else warn.bad = true; }
    const iv = p.get('i'), pi = iv ? parseInterior(iv) : null;
    if(iv && !pi) warn.bad = true;
    state.interior = pi || {module:true, shelves:CFG.module.defaultShelves};
    const hv = p.get('h'); state.handle = 'weiss';
    if(hv){ const hh = HKR[hv] || (CFG.handles[hv] ? hv : null); if(hh) state.handle = hh; else warn.bad = true; }
    const gg = grid();
    state.cubes = decodeCubes(p.get('c'), gg.cols*gg.rows, warn);
    const first = state.cubes.find(c=>c.door); if(first) state.brushDoor = first.door;
    state.interiorScope = 'all'; state.handleScope = 'all'; state.layer = 'door';
    state.setupOpen = false;
    return {ok:true, warn};
  }
  function pushUrl(){ try{ history.replaceState(null,'','#'+encode()); }catch(e){} }
  const shareUrl = () => location.href.split('#')[0] + '#' + encode();

  /* ---------- Tracking (Web Pixel / GA4 hängen sich an dataLayer oder das CustomEvent) ---------- */
  function track(ev, data){
    let payload = {event:ev};
    try{
      const t = totals(), g = grid();
      payload = Object.assign(payload, {raster:g.label, korpus:state.korpus, tueren:t.doors, module:t.mods, summe:Number(t.sum.toFixed(2))}, data||{});
    }catch(e){ payload = Object.assign(payload, data||{}); }
    try{ (window.dataLayer = window.dataLayer || []).push(payload); }catch(e){}
    try{ window.dispatchEvent(new CustomEvent('kallax:'+ev, {detail:payload})); }catch(e){}
    if(CFG.debugTracking && window.console) console.log('[kallax]', ev, payload);
  }

  /* ---------- Geometrie-Helfer ---------- */
  // Farbe abdunkeln/aufhellen; akzeptiert #hex und rgb(), gibt #hex zurück (damit Ergebnisse weiterverarbeitet werden können)
  function shade(col, f){
    let r,g,b;
    if(col[0]==='#'){ const n=parseInt(col.slice(1),16); r=(n>>16)&255; g=(n>>8)&255; b=n&255; }
    else { const m=col.match(/(\d+)/g)||[0,0,0]; r=+m[0]; g=+m[1]; b=+m[2]; }
    const c = x => Math.min(255,Math.max(0,Math.round(x*f))).toString(16).padStart(2,'0');
    return '#'+c(r)+c(g)+c(b);
  }
  function proj(v){ return (x,y,d)=>[x+v.kx*d, y+v.ky*d]; }
  function visible(n, v){ return n[0]*v.kx + n[1]*v.ky - n[2] > 1e-6; }
  function pts(P, list){ return list.map(p=>{const q=P(p[0],p[1],p[2]); return q[0].toFixed(2)+','+q[1].toFixed(2);}).join(' '); }
  function face(P, v, list, n, fill, extra){ if(!visible(n,v)) return ''; return `<polygon points="${pts(P,list)}" fill="${fill}" ${extra||''}/>`; }
  const N = { front:[0,0,-1], top:[0,-1,0], px:[1,0,0], nx:[-1,0,0] };

  function dims(){
    const g = grid(), G = CFG.geo;
    return { W: 2*G.tSide + g.cols*G.s + (g.cols-1)*G.tIn, H: 2*G.tTop + g.rows*G.s + (g.rows-1)*G.tIn, cols:g.cols, rows:g.rows };
  }
  function cubeOrigin(i){
    const g = grid(), G = CFG.geo;
    const r = Math.floor(i/g.cols), c = i%g.cols;
    return { x0: G.tSide + c*(G.s+G.tIn), y0: G.tTop + r*(G.s+G.tIn), r, c };
  }
  function viewBoxFor(view){
    const {W,H} = dims(), pad = 6, P = proj(CFG.views[view]);
    let minx=1e9,maxx=-1e9,miny=1e9,maxy=-1e9;
    for(const x of [0,W]) for(const y of [0,H]) for(const d of CFG.dRange){
      const q = P(x,y,d); minx=Math.min(minx,q[0]); maxx=Math.max(maxx,q[0]); miny=Math.min(miny,q[1]); maxy=Math.max(maxy,q[1]);
    }
    maxy += 4;
    let uw = maxx-minx+pad*2, uh = maxy-miny+pad*2;
    const ratio = Math.min(4/3, Math.max(1, uw/uh));
    if(uw/uh < ratio) uw = uh*ratio; else uh = uw/ratio;
    const cx=(minx+maxx)/2, cy=(miny+maxy)/2;
    return { vb:`${(cx-uw/2).toFixed(2)} ${(cy-uh/2).toFixed(2)} ${uw.toFixed(2)} ${uh.toFixed(2)}`, ratio };
  }

  /* ---------- Render-Engine: Licht, Materialien, Raum, Requisiten ---------- */
  // Lichtrichtung (zum Licht hin): von links oben vorn. Lambert + Ambient, normiert so, dass die Front 1,0 bekommt.
  const LIGHT = [-0.35,-0.55,-0.76];
  function lambert(n){ const d=Math.max(0, n[0]*LIGHT[0]+n[1]*LIGHT[1]+n[2]*LIGHT[2]); const a=0.72; let f=a+(1-a)*(d/0.76); if(n[1]<0) f*=1.06; return f; }
  function lit(col,n,f){ return shade(col, lambert(n)*(f||1)); }
  function hashStr(s){ let h=2166136261; for(let i=0;i<s.length;i++){ h^=s.charCodeAt(i); h=Math.imul(h,16777619); } return h>>>0; }
  function rng(seed){ let a=seed>>>0; return ()=>{ a|=0; a=a+0x6D2B79F5|0; let t=Math.imul(a^a>>>15,1|a); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; }; }

  // Gradienten werden pro Render gesammelt (ein Def je Farbe/Verlauf)
  let DEFS = null;
  function defGrad(kind, col, f1, f2){
    const id = kind + hashStr(col+f1+f2).toString(36);
    if(!DEFS.has(id)){
      const c1=shade(col,f1), c2=shade(col,f2);
      let g='';
      if(kind==='gv') g=`<linearGradient id="${id}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient>`;
      if(kind==='gd') g=`<linearGradient id="${id}" x1="0" y1="1" x2="1" y2="0"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient>`;
      if(kind==='gh') g=`<linearGradient id="${id}" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="${c1}"/><stop offset="0.35" stop-color="${shade(col,(f1+f2)/2+0.05)}"/><stop offset="1" stop-color="${c2}"/></linearGradient>`;
      if(kind==='gr') g=`<radialGradient id="${id}" cx="0.35" cy="0.3" r="0.75"><stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></radialGradient>`;
      DEFS.set(id,g);
    }
    return `url(#${id})`;
  }

  // Quader: Ecke vorn-links-unten (x, yb, df), Breite w, Höhe h, Tiefe dep (nach hinten)
  function box(P,v,x,yb,df,w,h,dep,col,o){
    o=o||{}; const yt=yb-h, db=df+dep; let s='';
    s += face(P,v,[[x,yt,df],[x+w,yt,df],[x+w,yt,db],[x,yt,db]], N.top, o.top||lit(col,N.top));
    s += face(P,v,[[x+w,yt,df],[x+w,yt,db],[x+w,yb,db],[x+w,yb,df]], N.px, lit(col,N.px));
    s += face(P,v,[[x,yt,df],[x,yt,db],[x,yb,db],[x,yb,df]], N.nx, lit(col,N.nx));
    s += face(P,v,[[x,yt,df],[x+w,yt,df],[x+w,yb,df],[x,yb,df]], N.front, o.front||defGrad('gv',col,1.0,0.93));
    return s;
  }
  // Zylinder, Mittelpunkt unten (cx, yb, cd)
  function cyl(P,v,cx,yb,cd,r,h,col){
    const b=P(cx,yb,cd), t=P(cx,yb-h,cd), ry=r*Math.hypot(v.kx,v.ky)*0.95;
    return `<ellipse cx="${b[0]}" cy="${b[1]}" rx="${r}" ry="${ry}" fill="${shade(col,0.7)}"/>`
      + `<rect x="${b[0]-r}" y="${t[1]}" width="${2*r}" height="${b[1]-t[1]}" fill="${defGrad('gh',col,1.02,0.66)}"/>`
      + `<ellipse cx="${t[0]}" cy="${t[1]}" rx="${r}" ry="${ry}" fill="${shade(col,1.08)}"/>`;
  }
  function sphere(P,v,cx,yb,cd,r,col){
    const c=P(cx,yb-r,cd);
    return `<ellipse cx="${c[0]+0.4}" cy="${c[1]+r*0.95}" rx="${r*0.95}" ry="${r*0.35}" fill="#000" opacity="0.18"/><circle cx="${c[0]}" cy="${c[1]}" r="${r}" fill="${defGrad('gr',col,1.12,0.62)}"/>`;
  }
  // Drehung um den projizierten Fußpunkt (für „unordentlich“)
  function tilt(P,x,yb,d,deg,inner){ const c=P(x,yb,d); return `<g transform="rotate(${deg.toFixed(1)} ${c[0].toFixed(2)} ${c[1].toFixed(2)})">${inner}</g>`; }

  const PAL = {
    kids:   { blocks:['#E9B84B','#E27A5F','#7FB2D6','#9FCDB0','#D2C7FF'], plush:'#D9C3A5', boxes:['#CFC5B8','#D2C7FF','#E5D8C6'], ball:'#E27A5F', car:'#5B8DBE', books:['#E9B84B','#7FB2D6','#9FCDB0','#E27A5F','#F1E7D0'] },
    office: { binders:['#4A4A48','#3E4A63','#EDEBE6','#8A8F8A','#C9BFB3'], paper:'#F7F6F2', plant:'#6E9B6A', leaf2:'#86AF80', pot:'#C8B9A6', box:'#CDBFAC', mug:'#F1EFEA', cable:'#5C5A57' },
    living: { books:['#8A6E58','#4E6B5E','#B76E5F','#E4DACB','#7C8C9A','#C9B79C','#5A4E48','#D2C7FF'], vase:'#C4795A', plant:'#6E9B6A', leaf2:'#86AF80', pot:'#EDE8E0', candle:'#F4F1EA', blanket:'#D7CBBD', bowl:'#9FA9A0', remote:'#3A3A38' }
  };

  // ---- Requisiten ----
  function fabricBox(P,v,x0,yb,col,handle){
    const w=30.5, h=30, dep=30, x=x0+1.5, df=4;
    let s = box(P,v,x,yb,df,w,h,dep,col);
    // Griffschlitz auf der Front
    const a=P(x+w/2-4,yb-h+8,df), b=P(x+w/2+4,yb-h+11,df);
    s += `<rect x="${a[0]}" y="${a[1]}" width="${b[0]-a[0]}" height="${b[1]-a[1]}" rx="1.4" fill="${shade(col,0.45)}"/>`;
    return s;
  }
  function bookRow(P,v,x,yb,d,books,lean){
    let s='', cx=x;
    books.forEach((bk,i)=>{
      const inner = box(P,v,cx,yb,d,bk.t,bk.h,bk.dep,bk.col,{front:shade(bk.col,0.9)});
      s += (lean && bk.lean) ? tilt(P,cx+bk.t,yb,d,bk.lean,inner) : inner;
      cx += bk.t + (bk.gap||0);
    });
    return s;
  }
  function flatStack(P,v,x,yb,d,items){ // liegende Bücher/Magazine, von unten nach oben
    let s='', y=yb;
    for(const it of items){ const inner = box(P,v,x+it.dx,y,d+it.dd,it.w,it.h,it.dep,it.col); s += it.rot ? tilt(P,x+it.dx+it.w/2,y,d+it.dd+it.dep/2,it.rot,inner) : inner; y -= it.h; }
    return s;
  }
  function binder(P,v,x,yb,d,col,labelCol){
    const w=7.5,h=29,dep=28;
    let s = box(P,v,x,yb,d,w,h,dep,col,{front:defGrad('gv',col,1.0,0.86)});
    const a=P(x+1.6,yb-h+5,d), b=P(x+w-1.6,yb-h+13,d);
    s += `<rect x="${a[0]}" y="${a[1]}" width="${b[0]-a[0]}" height="${b[1]-a[1]}" fill="${labelCol||'#F5F3EE'}"/>`;
    const r1=P(x+w/2,yb-h+18,d), r2=P(x+w/2,yb-6,d);
    s += `<circle cx="${r1[0]}" cy="${r1[1]}" r="0.8" fill="${shade(col,0.6)}"/><circle cx="${r2[0]}" cy="${r2[1]}" r="0.8" fill="${shade(col,0.6)}"/>`;
    return s;
  }
  function magFile(P,v,x,yb,d,col){ return box(P,v,x,yb,d,8,25,25,col,{top:shade(col,0.96)}); }
  function plant(P,v,cx,yb,cd,pal,scale){
    scale=scale||1; let s = cyl(P,v,cx,yb,cd,5*scale,7*scale,pal.pot);
    const t=P(cx,yb-7*scale,cd);
    const leaves=[[-30,6,2.6,pal.plant],[20,6.5,2.8,pal.leaf2],[-75,5,2.3,pal.plant],[70,5.5,2.4,pal.leaf2],[0,4.5,2.2,pal.plant]];
    leaves.forEach(l=>{ s += `<ellipse cx="${t[0]}" cy="${t[1]-4*scale}" rx="${l[1]*scale}" ry="${l[2]*scale}" fill="${l[3]}" transform="rotate(${l[0]} ${t[0]} ${t[1]-4*scale}) translate(${l[1]*scale*0.7} 0)"/>`; });
    return s;
  }
  function bear(P,v,cx,yb,cd,col){
    const b=P(cx,yb-6,cd), h=P(cx,yb-14.5,cd), e1=P(cx-3.6,yb-18,cd), e2=P(cx+3.6,yb-18,cd), m=P(cx,yb-13.2,cd);
    const g=defGrad('gr',col,1.1,0.7);
    return `<ellipse cx="${b[0]+0.5}" cy="${P(cx,yb,cd)[1]}" rx="6.5" ry="2" fill="#000" opacity="0.16"/>`
      + `<circle cx="${e1[0]}" cy="${e1[1]}" r="1.9" fill="${g}"/><circle cx="${e2[0]}" cy="${e2[1]}" r="1.9" fill="${g}"/>`
      + `<ellipse cx="${b[0]}" cy="${b[1]}" rx="6.2" ry="6.6" fill="${g}"/>`
      + `<ellipse cx="${b[0]-3}" cy="${b[1]+4.5}" rx="2.2" ry="1.6" fill="${shade(col,0.85)}"/><ellipse cx="${b[0]+3}" cy="${b[1]+4.5}" rx="2.2" ry="1.6" fill="${shade(col,0.85)}"/>`
      + `<circle cx="${h[0]}" cy="${h[1]}" r="4.8" fill="${g}"/>`
      + `<ellipse cx="${m[0]}" cy="${m[1]}" rx="2.1" ry="1.5" fill="${shade(col,1.18)}"/>`
      + `<circle cx="${h[0]-1.6}" cy="${h[1]-0.8}" r="0.45" fill="#2C2C2A"/><circle cx="${h[0]+1.6}" cy="${h[1]-0.8}" r="0.45" fill="#2C2C2A"/><circle cx="${m[0]}" cy="${m[1]-0.5}" r="0.5" fill="#2C2C2A"/>`;
  }
  function car(P,v,x,yb,d,col){
    let s = box(P,v,x,yb-1.6,d,10,3.6,5.5,col) + box(P,v,x+2.5,yb-5.2,d+0.5,5,2.6,4.5,shade(col,1.1));
    for(const wx of [x+2,x+8]){ const c=P(wx,yb-1.6,d-0.2); s += `<circle cx="${c[0]}" cy="${c[1]}" r="1.6" fill="#2C2C2A"/><circle cx="${c[0]}" cy="${c[1]}" r="0.7" fill="#8A8A88"/>`; }
    return s;
  }
  function mug(P,v,cx,yb,cd,col){ const t=P(cx,yb-4.5,cd); return cyl(P,v,cx,yb,cd,3.4,8,col) + `<path d="M${t[0]+3.4},${t[1]-1} a2.6,2.6 0 1,1 0,5.2" fill="none" stroke="${shade(col,0.85)}" stroke-width="1.1"/>`; }
  function papers(P,v,x,yb,d,r,pal){
    let s=''; for(let i=0;i<4;i++){ const inner = box(P,v,x+r()*3,yb,d+r()*4,21,0.5,29,pal.paper,{top:i%2?'#F3F1EC':'#FBFAF8'}); s += tilt(P,x+10,yb,d+14,(r()-0.5)*26,inner); }
    return s;
  }
  function cable(P,v,x0,yb,d0,col,r){
    const p=[]; for(let i=0;i<7;i++){ const q=P(x0+i*4+r()*2, yb-0.3, d0+Math.sin(i*1.7)*4+r()*3); p.push(q); }
    let dd=`M${p[0][0]},${p[0][1]}`; for(let i=1;i<p.length-1;i++){ const m=[(p[i][0]+p[i+1][0])/2,(p[i][1]+p[i+1][1])/2]; dd += ` Q${p[i][0]},${p[i][1]} ${m[0]},${m[1]}`; }
    return `<path d="${dd}" fill="none" stroke="${col}" stroke-width="0.9" stroke-linecap="round"/>`;
  }
  function blanket(P,v,x,yb,d,col){
    const c=P(x+15,yb,d+14); let s='';
    const g=defGrad('gr',col,1.08,0.78);
    s += `<ellipse cx="${c[0]}" cy="${c[1]-2}" rx="14" ry="6" fill="${g}"/>`;
    s += `<ellipse cx="${c[0]-4}" cy="${c[1]-7}" rx="10" ry="5" fill="${g}"/>`;
    s += `<ellipse cx="${c[0]+5}" cy="${c[1]-10}" rx="8" ry="4.2" fill="${g}"/>`;
    s += `<path d="M${c[0]-12},${c[1]-3} q6,-3 12,0 t10,-2" fill="none" stroke="${shade(col,0.82)}" stroke-width="0.6"/>`;
    return s;
  }
  function bowl(P,v,cx,yb,cd,col){ const b=P(cx,yb,cd), t=P(cx,yb-3.5,cd); const ry=7*Math.hypot(v.kx,v.ky); return `<ellipse cx="${b[0]}" cy="${b[1]}" rx="5.5" ry="${ry*0.8}" fill="${shade(col,0.7)}"/><path d="M${b[0]-5.5},${b[1]} L${t[0]-7},${t[1]} A7,${ry} 0 0,0 ${t[0]+7},${t[1]} L${b[0]+5.5},${b[1]} Z" fill="${defGrad('gh',col,1.0,0.7)}"/><ellipse cx="${t[0]}" cy="${t[1]}" rx="7" ry="${ry}" fill="${shade(col,0.55)}"/>`; }

  // ---- Szenen: pro Fach eine Variante (ordentlich / unordentlich) ----
  function propsFor(P,v,scene,kind,variant,seed,x0,yb){
    const r = rng(seed), pick = arr => arr[Math.floor(r()*arr.length)];
    let s = '';
    if(scene==='kids'){
      const pal = PAL.kids;
      if(kind==='tidy'){
        if(variant===0) s += fabricBox(P,v,x0,yb,pick(pal.boxes));
        else if(variant===1){
          s += flatStack(P,v,x0+5,yb,10,[{dx:0,dd:0,w:20,h:2.4,dep:16,col:pal.books[0]},{dx:1,dd:1,w:18,h:2.2,dep:15,col:pal.books[1]},{dx:2,dd:2,w:16,h:2.2,dep:14,col:pal.books[2]}]);
          s += sphere(P,v,x0+27,yb,12,4.2,pal.ball);
        } else {
          // Klötze als Pyramide + Bär sitzt ordentlich daneben
          const c=pal.blocks; s += box(P,v,x0+4,yb,12,5,5,5,c[0]) + box(P,v,x0+9.5,yb,12,5,5,5,c[1]) + box(P,v,x0+15,yb,12,5,5,5,c[2]) + box(P,v,x0+6.7,yb-5,12,5,5,5,c[3]) + box(P,v,x0+12.2,yb-5,12,5,5,5,c[4]) + box(P,v,x0+9.5,yb-10,12,5,5,5,c[0]);
          s += bear(P,v,x0+26,yb,14,pal.plush);
        }
      } else {
        if(variant===0){
          for(let i=0;i<7;i++){ const sz=3.8+r()*2.4; const inner=box(P,v,x0+2+r()*26,yb,4+r()*26,sz,sz,sz,pick(pal.blocks)); s += tilt(P,x0+15,yb,18,(r()-0.5)*40,inner); }
          s += sphere(P,v,x0+8+r()*16,yb,6+r()*10,4.5,pal.ball);
        } else if(variant===1){
          s += tilt(P,x0+12,yb,16,-18+r()*8, bear(P,v,x0+12,yb,16,pal.plush));
          s += car(P,v,x0+18,yb,6,pal.car);
          for(let i=0;i<3;i++){ const inner=box(P,v,x0+3+r()*24,yb,20+r()*10,4.5,4.5,4.5,pick(pal.blocks)); s += tilt(P,x0+15,yb,25,(r()-0.5)*30,inner); }
        } else {
          for(let i=0;i<4;i++){ const inner=box(P,v,x0+3+r()*10,yb-i*2.3,6+r()*10,17+r()*5,2.3,14,pick(pal.books)); s += tilt(P,x0+12,yb-i*2.3,14,(r()-0.5)*22,inner); }
          for(let i=0;i<3;i++){ s += box(P,v,x0+20+r()*8,yb,4+r()*20,4.5,4.5,4.5,pick(pal.blocks)); }
          s += sphere(P,v,x0+25,yb,24,3.5,pal.ball);
        }
      }
    }
    if(scene==='office'){
      const pal = PAL.office;
      if(kind==='tidy'){
        if(variant===0){ let x=x0+1.5; for(let i=0;i<4;i++){ s += binder(P,v,x,yb,4,pick(pal.binders)); x+=7.8; } }
        else if(variant===1){ s += magFile(P,v,x0+1.5,yb,5,pal.binders[2]) + magFile(P,v,x0+10,yb,5,pal.binders[0]) + plant(P,v,x0+26,yb,14,pal,0.9); }
        else { s += box(P,v,x0+2,yb,5,22,14,28,pal.box) + flatStack(P,v,x0+2,yb-14,5,[{dx:1,dd:2,w:20,h:2.6,dep:26,col:pal.paper}]) + mug(P,v,x0+28.5,yb,10,pal.mug); }
      } else {
        if(variant===0){
          let x=x0+1.5; const leans=[0,-9,-14,0]; for(let i=0;i<4;i++){ const inner=binder(P,v,x,yb,4,pick(pal.binders)); s += leans[i] ? tilt(P,x+7.5,yb,4,leans[i],inner) : inner; x += 7.8 + (i===1?4:0); }
        } else if(variant===1){ s += papers(P,v,x0+4,yb,3,r,pal) + mug(P,v,x0+8,yb,8,pal.mug) + box(P,v,x0+18,yb,20,10,6,12,pal.box); }
        else { s += cable(P,v,x0+2,yb,8,pal.cable,r) + tilt(P,x0+10,yb,20,-12, binder(P,v,x0+8,yb,18,pal.binders[1])) + flatStack(P,v,x0+14,yb,6,[{dx:0,dd:0,w:16,h:2.4,dep:22,col:pal.paper,rot:8},{dx:2,dd:3,w:14,h:2.2,dep:20,col:pal.binders[4],rot:-6}]); }
      }
    }
    if(scene==='living'){
      const pal = PAL.living;
      if(kind==='tidy'){
        if(variant===0){
          const books=[]; let total=0; while(total<24){ const t=1.6+r()*2; books.push({t,h:17+r()*7,dep:12+r()*4,col:pick(pal.books)}); total+=t; }
          s += bookRow(P,v,x0+2,yb,6,books,false);
          s += box(P,v,x0+2+total+0.5,yb,6,1.2,12,14,'#8A8A88');
        } else if(variant===1){ s += flatStack(P,v,x0+3,yb,8,[{dx:0,dd:0,w:20,h:2.6,dep:16,col:pal.books[3]},{dx:1,dd:1,w:18,h:2.4,dep:15,col:pal.books[0]}]) + cyl(P,v,x0+12,yb-5,15,3.8,13,pal.vase) + plant(P,v,x0+26,yb,10,pal,0.85) + cyl(P,v,x0+27,yb,26,2.4,7,pal.candle); }
        else { s += flatStack(P,v,x0+2,yb,10,[{dx:0,dd:0,w:14,h:2.4,dep:20,col:pal.books[1]},{dx:0.5,dd:0.5,w:13,h:2.2,dep:19,col:pal.books[5]},{dx:1,dd:1,w:12,h:2.2,dep:18,col:pal.books[3]}]) + bowl(P,v,x0+25,yb,16,pal.bowl); }
      } else {
        if(variant===0){
          const books=[]; let total=0; while(total<16){ const t=1.6+r()*2; books.push({t,h:17+r()*7,dep:12+r()*4,col:pick(pal.books),lean:-(6+r()*8),gap:r()*1.5}); total+=t; }
          s += bookRow(P,v,x0+2,yb,6,books,true);
          s += flatStack(P,v,x0+18,yb,8,[{dx:0,dd:0,w:13,h:2.2,dep:18,col:pick(pal.books),rot:14},{dx:2,dd:2,w:12,h:2,dep:17,col:pick(pal.books),rot:-9}]);
        } else if(variant===1){ s += blanket(P,v,x0+2,yb,6,pal.blanket) + tilt(P,x0+24,yb,20,25, box(P,v,x0+22,yb,20,4,1.2,14,pal.remote)); }
        else { s += flatStack(P,v,x0+4,yb,6,[{dx:0,dd:0,w:16,h:2.2,dep:22,col:pick(pal.books),rot:-18},{dx:3,dd:2,w:15,h:2,dep:21,col:pick(pal.books),rot:12},{dx:-1,dd:4,w:14,h:2.2,dep:20,col:pick(pal.books),rot:-4}]) + mug(P,v,x0+26,yb,12,'#F1EFEA'); }
      }
    }
    return s;
  }
  // Ordentlich einsortierter Inhalt für eine Ebene begrenzter Höhe (bei 1–2 Einlegeböden)
  function propsLevel(P,v,scene,seed,x0,yb,levelH,levelIdx,base){
    const r = rng(seed+levelIdx*7919), pick = arr => arr[Math.floor(r()*arr.length)];
    const tall = levelH >= 13;      // 1 Boden: ~15 cm je Ebene; 2 Böden: ~9,6 cm
    let s = '';
    const choice = (base + levelIdx) % 3;   // je Ebene eine andere Anordnung
    if(scene==='kids'){
      const pal = PAL.kids;
      if(choice===0){ s += flatStack(P,v,x0+3,yb,9,[{dx:0,dd:0,w:19,h:2.3,dep:15,col:pick(pal.books)},{dx:1,dd:1,w:17,h:2.2,dep:14,col:pick(pal.books)},{dx:2,dd:2,w:15,h:2.1,dep:13,col:pick(pal.books)}]); if(tall) s += sphere(P,v,x0+27,yb,12,3.6,pal.ball); else s += box(P,v,x0+25,yb,12,4.5,4.5,4.5,pick(pal.blocks)); }
      else if(choice===1){ let x=x0+3; for(let i=0;i<5;i++){ s += box(P,v,x,yb,10,4.6,4.6,4.6,pal.blocks[i%pal.blocks.length]); x+=5.2; } if(tall) s += car(P,v,x0+9,yb-0.2,22,pal.car); }
      else { if(tall) s += box(P,v,x0+2.5,yb,5,13,levelH-2.5,28,pick(pal.boxes)) + box(P,v,x0+17,yb,5,13,levelH-2.5,28,pick(pal.boxes)); else s += flatStack(P,v,x0+4,yb,8,[{dx:0,dd:0,w:22,h:2.2,dep:20,col:pick(pal.books)},{dx:0.5,dd:0.5,w:21,h:2.2,dep:19,col:pick(pal.books)}]) + box(P,v,x0+27,yb,14,4,4,4,pick(pal.blocks)); }
    }
    if(scene==='office'){
      const pal = PAL.office;
      if(choice===0){ s += flatStack(P,v,x0+3,yb,4,[{dx:0,dd:0,w:22,h:0.6,dep:29,col:pal.paper},{dx:0.3,dd:0.3,w:22,h:0.6,dep:29,col:'#F0EEE8'},{dx:0.6,dd:0.6,w:22,h:0.6,dep:29,col:pal.paper}]); if(tall) s += mug(P,v,x0+29,yb,10,pal.mug); else s += cyl(P,v,x0+29,yb,12,2,5.5,pal.binders[0]); }
      else if(choice===1){ s += flatStack(P,v,x0+2.5,yb,4,[{dx:0,dd:0,w:28,h:7.2,dep:29,col:pick(pal.binders)}]); if(tall) s += plant(P,v,x0+18,yb-7.2,16,pal,0.55); }
      else { s += box(P,v,x0+2.5,yb,5,14,Math.max(6,levelH-2.5),28,pal.box) + box(P,v,x0+17.5,yb,5,13,Math.max(5,levelH-3.5),28,'#E8E2D8'); }
    }
    if(scene==='living'){
      const pal = PAL.living;
      if(choice===0){ s += flatStack(P,v,x0+3,yb,8,[{dx:0,dd:0,w:20,h:2.4,dep:16,col:pick(pal.books)},{dx:1,dd:1,w:18,h:2.2,dep:15,col:pick(pal.books)}]); if(tall) s += cyl(P,v,x0+28,yb,14,2.4,7,pal.candle); else s += bowl(P,v,x0+27,yb,16,pal.bowl); }
      else if(choice===1){ if(tall){ const books=[]; let total=0; while(total<20){ const t=1.6+r()*1.8; books.push({t,h:9+r()*3.5,dep:11+r()*3,col:pick(pal.books)}); total+=t; } s += bookRow(P,v,x0+2.5,yb,7,books,false) + box(P,v,x0+2.5+total+0.4,yb,7,1.2,9,12,'#8A8A88'); } else { s += flatStack(P,v,x0+4,yb,6,[{dx:0,dd:0,w:16,h:2.2,dep:22,col:pick(pal.books)},{dx:0.5,dd:0.5,w:15,h:2,dep:21,col:pick(pal.books)},{dx:1,dd:1,w:14,h:2,dep:20,col:pick(pal.books)}]) + cyl(P,v,x0+27,yb,14,2.2,5.5,pal.candle); } }
      else { if(tall) s += cyl(P,v,x0+9,yb,14,3.4,10,pal.vase) + plant(P,v,x0+24,yb,12,pal,0.6); else s += bowl(P,v,x0+10,yb,14,pal.bowl) + flatStack(P,v,x0+18,yb,8,[{dx:0,dd:0,w:12,h:2.2,dep:18,col:pick(pal.books)},{dx:0.5,dd:0.5,w:11,h:2,dep:17,col:pick(pal.books)}]); }
    }
    return s;
  }
  function sceneAssign(){
    const n = state.cubes.length;
    const r = rng(hashStr(state.scene+'|'+grid().id+'|'+state.orient));
    const idx = [...Array(n).keys()];
    for(let i=n-1;i>0;i--){ const j=Math.floor(r()*(i+1)); [idx[i],idx[j]]=[idx[j],idx[i]]; }
    // jedes Fach ist befüllt: 3 unordentliche (bei kleinen Regalen die Hälfte), alle übrigen ordentlich
    const messy = n>=6 ? 3 : Math.ceil(n/2), tidy = n-messy;
    const m = new Map();
    // Varianten nach Rang vergeben, damit bei drei Fächern auch drei verschiedene Anordnungen erscheinen
    idx.slice(0,messy).forEach((i,k)=>m.set(i,{kind:'messy', variant:k%3}));
    idx.slice(messy,messy+tidy).forEach((i,k)=>m.set(i,{kind:'tidy', variant:k%3}));
    return m;
  }

  /* ---------- Szene rendern ---------- */
  function doorFrontFill(door,base){ if(door==='R') return 'url(#mirror)'; return defGrad('gv',base,1.0,0.94); }

  // opt: {labels, flash, hits} – für den Bild-Export ohne UI-Overlays aufrufen
  function buildScene(opt){
    opt = opt || {labels:true, flash:true, hits:true};
    const v = CFG.views[CFG.view], P = proj(v), G = CFG.geo, {W,H} = dims();
    const K = CFG.korpus[state.korpus].base, M = CFG.moduleColor;
    DEFS = new Map();
    const fit = viewBoxFor(CFG.view), vb = fit.vb.split(' ').map(Number);
    let out = '';

    // Raum: Wand + Boden, Übergang dort, wo die Rückkante des Regals steht
    const floorY = H + v.ky*G.D;
    out += `<rect x="${vb[0]}" y="${vb[1]}" width="${vb[2]}" height="${floorY-vb[1]}" fill="${defGrad('gv','#F4F2EE',1.0,0.965)}"/>`;
    out += `<rect x="${vb[0]}" y="${floorY}" width="${vb[2]}" height="${vb[1]+vb[3]-floorY}" fill="${defGrad('gv','#E8E4DC',0.93,1.03)}"/>`;
    out += `<rect x="${vb[0]}" y="${floorY-0.4}" width="${vb[2]}" height="0.8" fill="#000" opacity="0.06"/>`;
    // weicher Schatten des Regals auf Wand und Boden (Licht von links → Schatten rechts)
    const fp = [[-1,H+0.5,-4],[W+6,H+0.5,-4],[W+6,H+0.5,G.D],[-1,H+0.5,G.D]];
    out += `<polygon points="${pts(P,fp)}" fill="#2C2C2A" opacity="0.18" filter="url(#blur2)"/>`;
    out += `<polygon points="${pts(P,[[W,0,G.D],[W+9,2,G.D],[W+9,H,G.D],[W,H,G.D]])}" fill="#2C2C2A" opacity="0.10" filter="url(#blur2)"/>`;

    // Korpus außen
    out += face(P,v,[[0,0,0],[W,0,0],[W,0,G.D],[0,0,G.D]], N.top, defGrad('gd',K,1.0,0.92));
    out += face(P,v,[[W,0,0],[W,0,G.D],[W,H,G.D],[W,H,0]], N.px, defGrad('gd',K,0.78,0.7));
    out += face(P,v,[[0,0,0],[0,0,G.D],[0,H,G.D],[0,H,0]], N.nx, lit(K,N.nx));

    // Fächer
    const assign = state.scene==='empty' ? new Map() : sceneAssign();
    let clips = '', interiors = '';
    state.cubes.forEach((cube,i)=>{
      const {x0,y0} = cubeOrigin(i), s=G.s, x1=x0+s, y1=y0+s;
      clips += `<clipPath id="cl${i}"><rect x="${x0}" y="${y0}" width="${s}" height="${s}"/></clipPath>`;
      let g = `<g clip-path="url(#cl${i})">`;
      // KALLAX-Korpus innen: Rückwand (oben dunkler), Boden (nach hinten dunkler), Seitenwand
      g += face(P,v,[[x0,y0,G.D],[x1,y0,G.D],[x1,y1,G.D],[x0,y1,G.D]], N.front, defGrad('gv',K,0.6,0.78));
      g += face(P,v,[[x0,y1,0],[x1,y1,0],[x1,y1,G.D],[x0,y1,G.D]], N.top, defGrad('gd',K,0.96,0.7));
      g += face(P,v,[[x0,y0,0],[x0,y0,G.D],[x0,y1,G.D],[x0,y1,0]], N.px, defGrad('gd',K,0.84,0.62));
      g += face(P,v,[[x1,y0,0],[x1,y0,G.D],[x1,y1,G.D],[x1,y1,0]], N.nx, defGrad('gd',K,0.9,0.68));
      // Deckenschatten: dunkler Saum unter der Oberkante
      g += `<rect x="${x0}" y="${y0}" width="${s}" height="2.2" fill="${defGrad('gv','#000000',0,0)}" opacity="0.14"/>`;
      if(cube.door){
        const t=G.insT, ix0=x0+t, ix1=x1-t, dd=G.insD;
        g += face(P,v,[[ix0,y0,dd],[ix1,y0,dd],[ix1,y1,dd],[ix0,y1,dd]], N.front, defGrad('gv',M,0.72,0.86));
        g += face(P,v,[[ix0,y0,0],[ix0,y0,dd],[ix0,y1,dd],[ix0,y1,0]], N.px, defGrad('gd',M,0.9,0.7));
        g += face(P,v,[[ix1,y0,0],[ix1,y0,dd],[ix1,y1,dd],[ix1,y1,0]], N.nx, defGrad('gd',M,0.94,0.76));
        const it = eff(cube); const n = it.module ? it.shelves : 0;
        const a = assign.get(i), seed = hashStr(state.scene+'#'+i+'#'+grid().id);
        if(n===0){
          // ohne Boden (oder IKEA-Einsatz): Inhalt genau wie im offenen Fach, nur zwischen den Seitenwänden
          if(a) g += propsFor(P,v,state.scene,a.kind,a.variant,seed, x0+0.6, y1);
        } else {
          // mit Böden: Inhalt ordentlich auf die Ebenen einsortiert; Ebene 0 = unten
          const levelH = s/(n+1) - G.shelfT, base = Math.floor(rng(seed)()*3);
          if(a) g += propsLevel(P,v,state.scene,seed,x0+1,y1,levelH,0,base);
          for(let k=1;k<=n;k++){
            const yb = y0 + s*(n+1-k)/(n+1) - G.shelfT/2, yc = yb + G.shelfT;
            g += face(P,v,[[ix0,yb,1],[ix1,yb,1],[ix1,yb,dd],[ix0,yb,dd]], N.top, defGrad('gd',M,1.0,0.8));
            g += face(P,v,[[ix0,yb,1],[ix1,yb,1],[ix1,yc,1],[ix0,yc,1]], N.front, shade(M,0.95));
            g += face(P,v,[[ix0,yc,1],[ix1,yc,1],[ix1,yc+1.4,1.6],[ix0,yc+1.4,1.6]], N.top, '#000', 'opacity="0.10"');
            if(a) g += propsLevel(P,v,state.scene,seed,x0+1,yb,levelH,k,base);
          }
        }
        g += `<rect x="${x0}" y="${y0}" width="${t}" height="${s}" fill="${shade(M,1)}"/><rect x="${ix1}" y="${y0}" width="${t}" height="${s}" fill="${shade(M,1)}"/>`;
      } else if(assign.has(i)){
        const a = assign.get(i); g += propsFor(P,v,state.scene,a.kind,a.variant,hashStr(state.scene+'#'+i+'#'+grid().id), x0, y1);
      }
      g += '</g>';
      interiors += g;
    });
    out += clips + interiors;

    // Front-Gitter mit leichtem Verlauf, innere Kanten
    let path = `M0,0h${W}v${H}h${-W}z`;
    state.cubes.forEach((c,i)=>{ const {x0,y0}=cubeOrigin(i); path += ` M${x0},${y0}h${G.s}v${G.s}h${-G.s}z`; });
    out += `<path d="${path}" fill-rule="evenodd" fill="${defGrad('gv',K,1.0,0.95)}"/>`;
    state.cubes.forEach((c,i)=>{ const {x0,y0}=cubeOrigin(i); out += `<rect x="${x0}" y="${y0}" width="${G.s}" height="${G.s}" fill="none" stroke="#000" stroke-width="0.35" opacity="0.10"/>`; });

    // Türen als eigene Gruppe – während der Scharnier-Animation wird nur diese Gruppe neu gezeichnet
    out += `<g id="kx-doorLayer">${buildDoors(v, G)}</g>`;

    if(opt.labels && state.layer!=='door'){
      state.cubes.forEach((c,i)=>{
        const {x0,y0} = cubeOrigin(i), s=G.s, it=eff(c);
        let txt, exc;
        if(state.layer==='interior'){ txt = !c.door ? 'offen' : (!it.module ? 'IKEA-Einsatz' : shelfLabel(it.shelves)); exc = !!(c.door && c.interior); }
        else { const h=CFG.handles[effHandle(c)]; txt = !c.door ? 'offen' : (h.kind==='edge' ? h.short : h.short.toLowerCase()==='ohne griff' ? 'ohne Griff' : h.short); exc = !!(c.door && c.handle); }
        const w = Math.min(s-2, txt.length*2.15+4);
        out += `<g pointer-events="none"><rect x="${x0+s/2-w/2}" y="${y0+s-6.4}" width="${w}" height="4.6" fill="${exc?'#D2C7FF':'rgba(255,255,255,.9)'}" stroke="${exc?'#2C2C2A':'none'}" stroke-width="0.35"/><text x="${x0+s/2}" y="${y0+s-3.1}" text-anchor="middle" font-size="3.2" font-family="Assistant, system-ui, sans-serif" font-weight="${exc?'600':'500'}" fill="#2C2C2A">${txt}</text></g>`;
      });
    }
    if(opt.flash){
      const now = Date.now();
      state.cubes.forEach((c,i)=>{
        const t = state.flash.get(i); if(t===undefined || now-t>700) return;
        const {x0,y0} = cubeOrigin(i), s=G.s;
        out += `<rect class="kx-flash" x="${x0-0.8}" y="${y0-0.8}" width="${s+1.6}" height="${s+1.6}" fill="#D2C7FF" stroke="#D2C7FF" stroke-width="1.8"/>`;
      });
    }
    if(opt.hits){
      state.cubes.forEach((c,i)=>{
        const {x0,y0} = cubeOrigin(i), s=G.s;
        out += `<rect class="kx-hit" data-i="${i}" x="${x0}" y="${y0}" width="${s}" height="${s}" fill="transparent"><title>Fach ${i+1}</title></rect>`;
      });
    }

    const defs = `<defs>
      <linearGradient id="mirror" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#E3E8EA"/><stop offset="0.3" stop-color="#F9FAFA"/><stop offset="0.52" stop-color="#C3CBD0"/><stop offset="0.75" stop-color="#ECEFF0"/><stop offset="1" stop-color="#CFD6DA"/>
      </linearGradient>
      <linearGradient id="glow" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0.3" stop-color="#fff" stop-opacity="0"/><stop offset="0.46" stop-color="#fff" stop-opacity="0.6"/><stop offset="0.6" stop-color="#fff" stop-opacity="0"/>
      </linearGradient>
      <linearGradient id="revealTop" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#000" stop-opacity="0.34"/><stop offset="1" stop-color="#000" stop-opacity="0"/></linearGradient>
      <linearGradient id="revealLeft" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#000" stop-opacity="0.2"/><stop offset="1" stop-color="#000" stop-opacity="0"/></linearGradient>
      <linearGradient id="mirrorH" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#DDE2E5"/><stop offset="0.3" stop-color="#FAFBFB"/><stop offset="0.55" stop-color="#C5CCD1"/><stop offset="0.8" stop-color="#EEF1F2"/><stop offset="1" stop-color="#CFD6DA"/></linearGradient>
      <filter id="blur1" x="-10%" y="-10%" width="120%" height="120%"><feGaussianBlur stdDeviation="0.5"/></filter>
      <filter id="blur2" x="-20%" y="-50%" width="140%" height="200%"><feGaussianBlur stdDeviation="2.4"/></filter>
      ${[...DEFS.values()].join('')}
    </defs>`;

    return { markup: defs + out, vb: fit.vb, ratio: fit.ratio };
  }
  /* ---------- Türen bei beliebigem Öffnungswinkel + Scharnier-Animation ----------
     Scharnier links an der Vorderkante der Öffnung. u läuft über die Türbreite, sd über die Türstärke
     nach innen. Bei th = 0 liegt die Tür in der Öffnung (wie bisher), bei th = 90° steht sie offen. */
  function doorMarkup(P, v, cube, i, th, G){
    const {x0,y0} = cubeOrigin(i), s=G.s;
    const xa=x0+G.gap, xb=x0+s-G.gap, ya=y0+G.gap, yb=y0+s-G.gap;
    const base = CFG.doors[cube.door].base, w=G.doorW, t=G.doorT, dI=G.doorIn;
    const hd = CFG.handles[effHandle(cube)];
    const cs = Math.cos(th), sn = Math.sin(th);
    const M = (u,y,sd) => [xa + u*cs + sd*sn, y, dI - u*sn + sd*cs];
    const poly = list => list.map(p=>M(p[0],p[1],p[2]));
    const nOut=[-sn,0,-cs], nIn=[sn,0,cs], nFree=[cs,0,-sn], nHinge=[-cs,0,sn];
    const f = (list,n,fill,extra) => face(P, v, poly(list), n, fill, extra);
    const seated = th < 0.02;                       // praktisch geschlossen
    let out = '';

    if(!seated){
      // Korpus der Tür: Rückseite, freie Kante, Scharnierkante, Oberkante
      out += f([[0,ya,t],[w,ya,t],[w,yb,t],[0,yb,t]], nIn, defGrad('gd', cube.door==='R'?'#ECE8E0':base, 1.05, 0.9));
      out += f([[w,ya,0],[w,ya,t],[w,yb,t],[w,yb,0]], nFree, shade(base,0.94));
      out += f([[0,ya,0],[0,ya,t],[0,yb,t],[0,yb,0]], nHinge, shade(base,0.88));
      out += f([[0,ya,0],[w,ya,0],[w,ya,t],[0,ya,t]], N.top, shade(base,1.06));
    }
    // Sichtfläche
    out += f([[0,ya,0],[w,ya,0],[w,yb,0],[0,yb,0]], nOut, seated ? doorFrontFill(cube.door,base) : (cube.door==='R' ? 'url(#mirror)' : shade(base, 0.96 + 0.04*cs)));
    if(cube.door==='L'){
      const L=CFG.doors.L, gw=L.grooveW;
      for(let k=1;k<=L.grooves;k++){
        const gu = w*k/(L.grooves+1);
        out += f([[gu-gw/2,ya,0],[gu+gw/2,ya,0],[gu+gw/2,yb,0],[gu-gw/2,yb,0]], nOut, L.grooveDark);
        out += f([[gu+gw/2,ya,0],[gu+gw/2+0.1,ya,0],[gu+gw/2+0.1,yb,0],[gu+gw/2,yb,0]], nOut, L.grooveLight);
      }
    }
    if(cube.door==='R'){
      out += f([[0,ya,0],[w,ya,0],[w,yb,0],[0,yb,0]], nOut, 'url(#glow)');
      if(seated) out += f([[0,ya+s*0.58,0],[w,ya+s*0.58,0],[w,yb,0],[0,yb,0]], nOut, '#000', 'opacity="0.06"');
    }
    if(seated){
      // Laibungsschatten oben/links + Fuge: nur, solange die Tür in der Öffnung sitzt
      out += f([[0,ya,0],[w,ya,0],[w,ya+2.2,0],[0,ya+2.2,0]], nOut, 'url(#revealTop)');
      out += f([[0,ya,0],[1.4,ya,0],[1.4,yb,0],[0,yb,0]], nOut, 'url(#revealLeft)');
      out += `<polygon points="${pts(P, poly([[0,ya,0],[w,ya,0],[w,yb,0],[0,yb,0]]))}" fill="none" stroke="#000" stroke-width="0.3" opacity="0.35"/>`;
    }
    // Griff: Kantengriff oben bündig an der freien Kante, Knopf rechts mittig
    if(hd && hd.kind==='edge'){
      const hw=Math.min(hd.w || G.handleW, G.doorW), u0=w-hw;
      out += f([[u0,ya+0.3,0],[w,ya+0.3,0],[w,ya+1.3,0],[u0,ya+1.3,0]], nOut, '#000', `opacity="${(0.18*cs*cs).toFixed(3)}"`);
      out += f([[u0,ya-0.5,-0.3],[w,ya-0.5,-0.3],[w,ya+0.45,-0.3],[u0,ya+0.45,-0.3]], nOut, hd.col==='mirror' ? 'url(#mirrorH)' : defGrad('gv',hd.col,1.08,0.8));
      out += f([[u0,ya-0.5,-0.3],[w,ya-0.5,-0.3],[w,ya-0.5,0.9],[u0,ya-0.5,0.9]], N.top, hd.col==='mirror' ? '#F2F4F5' : shade(hd.col,1.12));
      out += f([[w,ya-0.5,-0.3],[w,ya-0.5,0.9],[w,ya+0.45,0.9],[w,ya+0.45,-0.3]], nFree, hd.col==='mirror' ? '#C9D0D4' : shade(hd.col,0.8));
    } else if(hd && hd.kind==='knob'){
      const q = M(w-4, (ya+yb)/2, -1.2), kc = P(q[0],q[1],q[2]);
      out += `<ellipse cx="${(kc[0]+0.5).toFixed(2)}" cy="${(kc[1]+0.6).toFixed(2)}" rx="1.7" ry="1.4" fill="#000" opacity="${(0.22*cs*cs).toFixed(3)}"/>`;
      out += `<circle cx="${kc[0].toFixed(2)}" cy="${kc[1].toFixed(2)}" r="1.5" fill="${defGrad('gr',hd.col,1.9,0.8)}"/>`;
    }
    return out;
  }
  function buildDoors(v, G){
    const P = proj(v);
    // spaltenweise stapeln: geöffnete Türen schwenken nach vorn über den Nachbarn
    const order = state.cubes.map((c,i)=>i).sort((a,b)=>{ const A=cubeOrigin(a), B=cubeOrigin(b); if(A.r!==B.r) return A.r-B.r; return v.kx<0 ? B.c-A.c : A.c-B.c; });
    let out = '';
    for(const i of order){
      const cube = state.cubes[i]; if(!cube.door) continue;
      out += doorMarkup(P, v, cube, i, doorAngle(), G);
    }
    return out;
  }

  /* ---------- Türen: fester Winkel, keine Animation ---------- */
  const DEG = Math.PI/180;
  const doorAngle = () => state.open ? 90*DEG : 0;

  function renderScene(){
    const b = buildScene({labels:true, flash:true, hits:true});
    const svg = $('svg');
    svg.setAttribute('viewBox', b.vb);
    $('scene').style.aspectRatio = String(b.ratio);
    svg.innerHTML = b.markup;
  }

  /* ---------- UI ---------- */
  const $ = id => document.getElementById('kx-' + id);
  const money = (function(){
    try{
      const f = new Intl.NumberFormat(CFG.locale, {style:'currency', currency:CFG.currency});
      return n => f.format(n);
    }catch(e){ return n => n.toFixed(2).replace('.', ',') + ' €'; }
  })();
  const eur = n => money(n);

  function interiorPrice(it){ return it.module ? modulePrice(it.shelves) : 0; }
  function cubePrice(c){ if(!c.door) return 0; return CFG.doors[c.door].price + interiorPrice(eff(c)) + CFG.handles[effHandle(c)].price; }
  function totals(){
    let sum=0, doors=0, mods=0, tuerOnly=0, handles=0;
    for(const c of state.cubes){
      const it=eff(c); sum+=cubePrice(c);
      if(c.door){ doors++; if(CFG.handles[effHandle(c)].kind!=='none') handles++; }
      if(it&&it.module) mods++; if(it&&!it.module) tuerOnly++;
    }
    return {sum,doors,mods,tuerOnly,handles};
  }
  const excIntCount = () => state.cubes.filter(c=>c.door && c.interior).length;
  const excHndCount = () => state.cubes.filter(c=>c.door && c.handle).length;
  function renderSetup(){
    $('gridRow').innerHTML = CFG.sizes.map(g=>`<button class="kx-chip" data-grid="${g.id}" aria-pressed="${g.id===state.size}">${g.a}×${g.b}</button>`).join('');
    const gsel = document.querySelector('#kx-gridRow [aria-pressed="true"]');
    if(gsel && gsel.scrollIntoView && state.setupOpen) gsel.scrollIntoView({block:'nearest', inline:'center'});
    $('orientRow').hidden = grid().square;
    document.querySelectorAll('#kx-orientRow button').forEach(b=>b.setAttribute('aria-pressed', String(b.dataset.orient===state.orient)));
    $('korpusRow').innerHTML = Object.entries(CFG.korpus).map(([k,o])=>`<button class="kx-chip" data-korpus="${k}" aria-pressed="${k===state.korpus}"><span class="kx-sw" style="background:${o.base}"></span>${o.name}</button>`).join('');
    $('setup').hidden = !state.setupOpen;
    $('summary').hidden = state.setupOpen;
    $('summaryText').textContent = `${grid().label} · ${CFG.korpus[state.korpus].name}`;
  }
  function renderControls(){
    renderSetup();
    $('openToggle').setAttribute('aria-pressed', String(state.open));
    document.querySelectorAll('#kx-sceneRow button').forEach(b=>b.setAttribute('aria-pressed', String(b.dataset.scene===state.scene)));
    const g = grid(), {W,H} = dims();
    $('sceneTag').textContent = `${g.label} · ${Math.round(W)} × ${Math.round(H)} cm`;
    const counts = {};
    for(const c of state.cubes){ if(!c.door) continue; counts[c.door]=(counts[c.door]||0)+1; }
    const open = state.cubes.filter(c=>!c.door).length;
    $('legend').innerHTML = Object.entries(counts).map(([k,n])=>{ const d=CFG.doors[k]; return `<span style="--k:${d.base}">${n}× ${d.name} ${d.finish}</span>`; }).join('')
      + (open && open<state.cubes.length ? `<span style="--k:${CFG.korpus[state.korpus].base}">${open}× offen</span>` : '');
    const t = totals();
    $('total').textContent = eur(t.sum);
    const parts = [];
    if(t.doors) parts.push(`${t.doors} ${t.doors===1?'Tür':'Türen'}`);
    if(t.mods) parts.push(`${t.mods} ${t.mods===1?'Einsatz':'Einsätze'}`);
    if(t.handles) parts.push(`${t.handles} ${t.handles===1?'Griff':'Griffe'}`);
    if(t.tuerOnly) parts.push(`${t.tuerOnly}× IKEA*-Einsatz nötig`);
    $('sumsub').textContent = parts.length ? parts.join(' · ') : 'Noch keine Tür gewählt';
    $('atc').disabled = t.doors===0;
  }

  // Piktogramm: Fach mit Einsatz = zwei Seitenwände (+ Böden dazwischen); ohne Modul = gestrichelter IKEA-Einsatz
  function icoInterior(o){
    const cube = '<rect x="3" y="3" width="34" height="34" fill="none" stroke="#B9B5AD" stroke-width="1.5"/>';
    const walls = o.module
      ? '<rect x="7" y="3" width="4" height="34" fill="#2C2C2A"/><rect x="29" y="3" width="4" height="34" fill="#2C2C2A"/>'
      : '<rect x="7" y="3" width="4" height="34" fill="none" stroke="#7A756C" stroke-width="1.5" stroke-dasharray="2.5 2"/><rect x="29" y="3" width="4" height="34" fill="none" stroke="#7A756C" stroke-width="1.5" stroke-dasharray="2.5 2"/>';
    let lines = '';
    if(o.module && o.shelves===1) lines = '<rect x="11" y="19" width="18" height="2.5" fill="#2C2C2A"/>';
    if(o.module && o.shelves===2) lines = '<rect x="11" y="13" width="18" height="2.5" fill="#2C2C2A"/><rect x="11" y="24.5" width="18" height="2.5" fill="#2C2C2A"/>';
    if(o.module && o.shelves===3) lines = '<rect x="11" y="10.5" width="18" height="2.5" fill="#2C2C2A"/><rect x="11" y="19" width="18" height="2.5" fill="#2C2C2A"/><rect x="11" y="27.5" width="18" height="2.5" fill="#2C2C2A"/>';
    return `<svg viewBox="0 0 40 40">${cube}${walls}${lines}</svg>`;
  }
  const sameInt = (a,b) => a.module===b.module && (!a.module || a.shelves===b.shelves);
  const shelfLabel = n => n===0 ? 'ohne Boden' : n===1 ? '1 Boden' : n+' Böden';
  function interiorSwatches(selected, attr, badgeDefault){
    return INTERIOR_OPTIONS.map(o=>{
      const name = !o.module ? 'Kein Einsatz' : 'Einsatz';
      const sub = !o.module ? 'IKEA*-Einsatz' : shelfLabel(o.shelves);
      const badge = badgeDefault && o.module && o.shelves===CFG.module.defaultShelves ? '<span class="kx-badge">Empfohlen</span>' : '';
      const soft = o.module ? '<span class="kx-sc">inkl. Soft-Close-Scharnier</span>' : '';
      return `<button class="kx-swatch" ${attr}="${encInt(o)}" aria-pressed="${sameInt(selected,o)}">${badge}<span class="kx-tile kx-ico" aria-hidden="true">${icoInterior(o)}</span><span class="kx-n">${name}</span><span class="kx-f">${sub}</span><span class="kx-pr">${o.module ? eur(interiorPrice(o)) : '–'}</span>${soft}</button>`;
    }).join('');
  }

  // Piktogramm: Tür mit Griff. Kantengriff sitzt oben rechts an der Kante – wie in der Szene.
  function icoHandle(h){
    const door = '<rect x="4" y="6" width="32" height="30" fill="#EFEDE8" stroke="#B9B5AD" stroke-width="1"/>';
    if(h.kind==='none') return `<svg viewBox="0 0 40 40">${door}<path d="M14,21 h12" stroke="#B9B5AD" stroke-width="1.4" stroke-dasharray="2.5 2.5"/></svg>`;
    if(h.kind==='knob') return `<svg viewBox="0 0 40 40">${door}<circle cx="29" cy="21" r="3.2" fill="${h.col}"/><circle cx="28" cy="20" r="1" fill="#fff" opacity="0.5"/></svg>`;
    const fill = h.col==='mirror' ? 'url(#icoMirror)' : h.col;
    return `<svg viewBox="0 0 40 40"><defs><linearGradient id="icoMirror" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#D9DEE1"/><stop offset="0.4" stop-color="#FAFBFB"/><stop offset="0.7" stop-color="#C3CBD0"/><stop offset="1" stop-color="#ECEFF0"/></linearGradient></defs>${door}<rect x="16" y="4" width="20" height="4" fill="${fill}" stroke="#8E8A83" stroke-width="0.6"/><rect x="16" y="8" width="20" height="1.2" fill="#000" opacity="0.15"/></svg>`;
  }
  // Fünf Optionen in einer Zeile: die drei Kantengriffe tragen die Farbe als Überschrift,
  // „Kantengriff" steht als gemeinsame Unterzeile darunter und gruppiert sie optisch.
  function handleSwatches(selected, attr){
    return Object.values(CFG.handles).map(h=>`<button class="kx-swatch" ${attr}="${h.key}" aria-pressed="${selected===h.key}"><span class="kx-tile kx-ico" aria-hidden="true">${icoHandle(h)}</span><span class="kx-n">${h.short}</span><span class="kx-f">${h.group || '&nbsp;'}</span><span class="kx-pr">${h.kind==='none' ? '–' : eur(h.price)}</span></button>`).join('');
  }
  function renderPanel(){
    // Türen
    const dv = state.brushDoor || 'none';
    $('doorSwatches').innerHTML =
      `<button class="kx-swatch" data-door="none" aria-pressed="${dv==='none'}"><span class="kx-tile kx-none" aria-hidden="true"></span><span class="kx-n">Keine Tür</span><span class="kx-f">offenes Fach</span><span class="kx-pr">0,00 €</span></button>` +
      Object.values(CFG.doors).map(x=>`
      <button class="kx-swatch" data-door="${x.key}" aria-pressed="${dv===x.key}">
        <span class="kx-tile kx-${x.key}" aria-hidden="true"></span>
        <span class="kx-n">${x.name}</span><span class="kx-f">${x.finish}</span><span class="kx-pr">${eur(x.price)}</span>
      </button>`).join('');

    const doorsCount = state.cubes.filter(c=>c.door).length;
    const intSingle = state.interiorScope==='single', hndSingle = state.handleScope==='single';
    const nInt = excIntCount(), nHnd = excHndCount();
    const abw = n => `${n} ${n===1?'Fach weicht':'Fächer weichen'} ab`;

    // Innenleben: eine Palette, zwei Bedeutungen – Standard für alle oder Pinsel für einzelne Fächer
    const it = intSingle ? state.excBrush : state.interior;
    $('stdRow').innerHTML = interiorSwatches(it, 'data-std', !intSingle);
    $('warn').hidden = !(it.module===false || totals().tuerOnly>0);
    document.querySelectorAll('#kx-intScope button').forEach(b=>b.setAttribute('aria-pressed', String((b.dataset.iscope==='single')===intSingle)));
    $('interiorSub').innerHTML = intSingle
      ? (doorsCount ? 'Einsatz wählen, dann Fächer antippen oder darüberwischen.' : 'Erst Türen malen – einen Einsatz gibt es nur hinter einer Tür.')
      : 'Notwendig, um die Tür zu montieren.' + (nInt ? ` · ${abw(nInt)}` : '');
    $('intMeta').hidden = !(intSingle || nInt);
    $('excCount').textContent = nInt ? `${nInt} ${nInt===1?'Ausnahme':'Ausnahmen'}` : 'Noch keine Ausnahmen';
    $('excReset').disabled = nInt===0;

    // Griffe: gleiches Prinzip, Weiß ist vorausgewählt
    const hsel = hndSingle ? state.excHandle : state.handle;
    $('handleRow').innerHTML = handleSwatches(hsel, 'data-handle');
    $('handleWarn').hidden = !(hsel==='ohne' || state.cubes.some(c=>c.door && CFG.handles[effHandle(c)].kind==='none'));
    document.querySelectorAll('#kx-hndScope button').forEach(b=>b.setAttribute('aria-pressed', String((b.dataset.hscope==='single')===hndSingle)));
    $('handleSub').innerHTML = hndSingle
      ? (doorsCount ? 'Griff wählen, dann Fächer antippen oder darüberwischen.' : 'Erst Türen malen – ein Griff gehört immer zu einer Tür.')
      : 'Ein Griff ist notwendig, um die Tür öffnen zu können.' + (nHnd ? ` · ${abw(nHnd)}` : '');
    $('hndMeta').hidden = !(hndSingle || nHnd);
    $('hexCount').textContent = nHnd ? `${nHnd} ${nHnd===1?'Ausnahme':'Ausnahmen'}` : 'Noch keine Ausnahmen';
    $('hexReset').disabled = nHnd===0;

    $('modePill').hidden = state.layer==='door';
    $('modePill').textContent = state.layer==='interior' ? 'Du malst: Einsätze' : 'Du malst: Griffe';
  }

  function renderAll(){ renderControls(); renderScene(); renderPanel(); pushUrl(); saveSoon(); }

  // Setup (Größe + Korpus) klappt ein, sobald der Kunde weitergeht
  function collapseSetup(){ if(state.setupOpen){ state.setupOpen=false; renderSetup(); } }
  function maybeCollapse(){ if(state.touched.size && state.touched.korpus) collapseSetup(); }

  // Verlauf nur für Tastatur-Undo (Ctrl/Cmd+Z) – keine sichtbaren Buttons
  const cloneCube = c => ({door:c.door, interior:c.interior?{...c.interior}:null, handle:c.handle||null});
  function snapshot(){ state.history.push(state.cubes.map(cloneCube)); if(state.history.length>30) state.history.shift(); }
  function undo(){ const h=state.history.pop(); if(!h) return; state.cubes = h.map(cloneCube); state.flash.clear(); track('undo'); renderAll(); }
  // Malen: Tür-Ebene setzt nur die Tür, Innen-/Griff-Ebene nur die Ausnahme.
  // Wer den Standardwert malt, hebt die Ausnahme auf (interior/handle = null) – sonst würde die Ausnahmezahl lügen.
  function paint(indices){
    let changed=false;
    for(const i of indices){
      const c = state.cubes[i];
      if(state.layer==='door'){ if(c.door!==state.brushDoor){ c.door=state.brushDoor; changed=true; } }
      else if(state.layer==='interior'){
        if(!c.door) continue;
        const b=state.excBrush, target = sameInt(b, state.interior) ? null : {...b};
        if(!sameInt(eff(c), b) || (c.interior && !target)){ c.interior=target; changed=true; }
      }
      else {
        if(!c.door) continue;
        const target = state.excHandle===state.handle ? null : state.excHandle;
        if(effHandle(c)!==state.excHandle || (c.handle && !target)){ c.handle=target; changed=true; }
      }
      state.flash.set(i, Date.now());
    }
    collapseSetup(); renderAll();
    return changed;
  }
  // Malebene folgt den beiden Umfang-Schaltern; nur eine kann „einzeln" sein
  function applyLayer(){
    const next = state.interiorScope==='single' ? 'interior' : (state.handleScope==='single' ? 'handle' : 'door');
    if(next===state.layer) return;
    if(state.layer==='door') state.openBefore = state.open;      // Zustand merken, wenn wir die Tür-Ebene verlassen
    if(next==='interior'){
      state.open = true;                                          // Innenleben: Türen auf
      if(sameInt(state.excBrush, state.interior)) state.excBrush = state.interior.module ? {module:false, shelves:CFG.module.defaultShelves} : {module:true, shelves:CFG.module.defaultShelves};
    } else if(next==='handle'){
      state.open = false;                                         // Griffe: Türen zu, damit man sie sieht
      if(state.excHandle===state.handle) state.excHandle = state.handle==='weiss' ? 'schwarz' : 'weiss';
    } else { state.open = state.openBefore; }
    state.layer = next;
  }
  function setScope(which, scope){
    if(which==='interior'){
      if(state.interiorScope===scope) return;
      state.interiorScope = scope; if(scope==='single') state.handleScope = 'all';
    } else {
      if(state.handleScope===scope) return;
      state.handleScope = scope; if(scope==='single') state.interiorScope = 'all';
    }
    // Zurück auf „Alle" ändert bewusst NICHTS an den Fächern – erst die nächste Auswahl vereinheitlicht.
    applyLayer(); track('exception_mode', {layer:which, on:scope==='single'}); collapseSetup(); renderAll();
  }
  function backToDoorLayer(){ state.interiorScope='all'; state.handleScope='all'; applyLayer(); }

  /* ---------- Klartext-Zusammenfassung (Teilen, Bild, Wiederkehr) ---------- */
  function configLines(){
    const g = grid(), counts = {};
    for(const c of state.cubes){ if(c.door) counts[c.door] = (counts[c.door]||0)+1; }
    const doorTxt = Object.entries(counts).map(([k,n])=>`${n}× ${CFG.doors[k].name}`).join(' · ');
    const open = state.cubes.filter(c=>!c.door).length;
    const it = state.interior, h = CFG.handles[state.handle];
    const intTxt = excIntCount() ? 'Einsätze gemischt'
      : (it.module ? `ABOUT SHELVES Einsatz, ${shelfLabel(it.shelves)}` : 'ohne unseren Einsatz (IKEA*-Einsatz)');
    const hTxt = excHndCount() ? 'Griffe gemischt' : h.label;
    return [
      `KALLAX ${g.label} · ${CFG.korpus[state.korpus].name}`,
      [doorTxt, open ? `${open}× offen` : ''].filter(Boolean).join(' · ') || 'noch keine Tür gewählt',
      state.cubes.some(c=>c.door) ? `${intTxt} · ${hTxt}` : ''
    ].filter(Boolean);
  }

  /* ---------- Wiederkehr: letzte Konfiguration im localStorage ---------- */
  let saveTimer = null, pendingRestore = null;
  function saveLocal(){
    try{
      if(!state.cubes.some(c=>c.door)){ localStorage.removeItem(CFG.storageKey); return; }
      localStorage.setItem(CFG.storageKey, JSON.stringify({h:encode(), t:Date.now(), s:configLines().join(' · '), p:totals().sum}));
    }catch(e){}   // Privater Modus / Speicher voll: einfach ohne Auto-Save weiterlaufen
  }
  function saveSoon(){ clearTimeout(saveTimer); saveTimer = setTimeout(saveLocal, 500); }
  function offerRestore(){
    let raw = null;
    try{ raw = localStorage.getItem(CFG.storageKey); }catch(e){ return; }
    if(!raw) return;
    let d = null; try{ d = JSON.parse(raw); }catch(e){ return; }
    if(!d || typeof d.h !== 'string') return;
    if(Date.now() - (d.t||0) > CFG.storageMaxAgeDays*864e5) return;
    pendingRestore = d;
    $('restoreSub').textContent = (d.s||'') + (typeof d.p === 'number' ? ' · ' + eur(d.p) : '');
    $('restore').hidden = false;
  }

  /* ---------- Teilen ---------- */
  let toastTimer = null;
  function toast(msg){ const t=$('toast'); t.textContent=msg; t.classList.add('kx-on'); clearTimeout(toastTimer); toastTimer=setTimeout(()=>t.classList.remove('kx-on'), 2600); }
  const coarse = () => { try{ return window.matchMedia('(pointer:coarse)').matches; }catch(e){ return false; } };
  async function shareConfig(){
    const url = shareUrl(), text = configLines().join(' · ');
    if(navigator.share && coarse()){
      try{ await navigator.share({title:CFG.shareTitle, text, url}); track('config_shared', {method:'webshare'}); return; }
      catch(e){ if(e && e.name==='AbortError') return; }
    }
    try{ await navigator.clipboard.writeText(url); toast('Link kopiert'); track('config_shared', {method:'copy'}); }
    catch(e){ toast('Kopieren blockiert – Link steht in der Adresszeile'); }
  }

  /* ---------- Bild-Export 4:5 mit Wortmarke ---------- */
  let shotBlob = null, shotUrl = null;
  function wrapText(ctx, text, maxW){
    const words = String(text).split(' '), lines = []; let cur = '';
    for(const w of words){ const t = cur ? cur+' '+w : w; if(ctx.measureText(t).width > maxW && cur){ lines.push(cur); cur = w; } else cur = t; }
    if(cur) lines.push(cur); return lines;
  }
  function svgToImage(markup, vb, w, h){
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="${vb}" preserveAspectRatio="xMidYMid meet">${markup}</svg>`;
    return new Promise((res,rej)=>{
      const img = new Image();
      img.onload = ()=>res(img); img.onerror = rej;
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    });
  }
  async function buildShot(){
    const W = 1080, H = 1350, pad = 72;
    try{ if(document.fonts && document.fonts.ready) await document.fonts.ready; }catch(e){}
    const b = buildScene({labels:false, flash:false, hits:false});
    const boxW = W - pad*2, boxH = 800;
    const iw = Math.min(boxW, boxH*b.ratio), ih = iw/b.ratio;
    const img = await svgToImage(b.markup, b.vb, Math.round(iw*2), Math.round(ih*2));

    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const ctx = cv.getContext('2d');
    ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0,0,W,H);

    // Wortmarke im Rahmen – wie im Shop-Header
    ctx.font = '500 22px "Tenor Sans", Georgia, serif';
    const brand = CFG.brand.split('').join(' '); // leichte Spationierung
    const bw = ctx.measureText(brand).width + 34;
    ctx.strokeStyle = '#2C2C2A'; ctx.lineWidth = 1.5; ctx.strokeRect(pad, pad, bw, 52);
    ctx.fillStyle = '#2C2C2A'; ctx.textBaseline = 'middle';
    ctx.fillText(brand, pad+17, pad+27);

    // Szene
    const sceneTop = pad + 92;
    ctx.fillStyle = '#F4F2EE'; ctx.fillRect(pad, sceneTop, boxW, boxH);
    ctx.drawImage(img, pad + (boxW-iw)/2, sceneTop + (boxH-ih)/2, iw, ih);

    // Konfiguration als Klartext
    let y = sceneTop + boxH + 66;
    ctx.font = '400 20px Assistant, system-ui, sans-serif'; ctx.fillStyle = 'rgba(44,44,42,.62)';
    ctx.fillText('D E I N   K A L L A X', pad, y); y += 46;
    const lines = configLines();
    ctx.font = '500 38px Assistant, system-ui, sans-serif'; ctx.fillStyle = '#2C2C2A';
    for(const l of wrapText(ctx, lines[0], boxW)){ ctx.fillText(l, pad, y); y += 48; }
    ctx.font = '300 30px Assistant, system-ui, sans-serif'; ctx.fillStyle = 'rgba(44,44,42,.78)';
    for(const line of lines.slice(1)){ for(const l of wrapText(ctx, line, boxW)){ ctx.fillText(l, pad, y); y += 40; } }

    ctx.font = '400 24px Assistant, system-ui, sans-serif'; ctx.fillStyle = 'rgba(44,44,42,.62)';
    ctx.fillText(CFG.domain, pad, H - pad);
    ctx.fillStyle = '#D2C7FF'; ctx.fillRect(pad, H - pad - 44, 64, 4);

    return new Promise(res => cv.toBlob(b2 => res(b2), 'image/png'));
  }
  const shotName = () => 'kallax-' + grid().label.replace(/[^0-9x×]/gi,'').replace('×','x') + '.png';
  async function exportShot(){
    $('shotBtn').disabled = true;
    try{
      shotBlob = await buildShot();
      if(shotUrl) URL.revokeObjectURL(shotUrl);
      shotUrl = URL.createObjectURL(shotBlob);
      $('shotImg').src = shotUrl;
      $('shotModal').classList.add('kx-on');
      $('shotNote').textContent = coarse() ? 'Lange auf das Bild drücken zum Sichern – oder unten teilen.' : 'Rechtsklick auf das Bild → „Bild speichern unter", oder unten sichern.';
      track('config_image_exported', {method:'preview'});
    }catch(e){ toast('Bild konnte nicht erzeugt werden'); }
    $('shotBtn').disabled = false;
  }
  function saveShot(){
    if(!shotBlob) return;
    try{
      const a = document.createElement('a'); a.href = shotUrl; a.download = shotName();
      document.body.appendChild(a); a.click(); a.remove();
      track('config_image_exported', {method:'download'});
    }catch(e){ toast('Download hier blockiert – Bild lange drücken'); }
  }
  async function shareShot(){
    if(!shotBlob) return;
    try{
      const file = new File([shotBlob], shotName(), {type:'image/png'});
      if(navigator.canShare && navigator.canShare({files:[file]})){
        await navigator.share({files:[file], title:CFG.shareTitle, text:configLines().join(' · ')});
        track('config_shared', {method:'webshare_image'}); return;
      }
    }catch(e){ if(e && e.name==='AbortError') return; }
    saveShot();
  }

  /* ---------- Warenkorb-Simulation ---------- */
  function buildCart(){
    const agg = new Map();
    const add = (id, title, price, qty=1) => { const k=String(id); const e=agg.get(k)||{id,title,price,quantity:0}; e.quantity+=qty; agg.set(k,e); };
    state.cubes.forEach(c=>{
      if(!c.door) return;
      const d = CFG.doors[c.door];
      add(d.variantId, `${d.name} : Tür für KALLAX* – ${d.finish}`, d.price);
      const it = eff(c);
      if(it.module){
        add(CFG.module.baseVariantId, CFG.module.name, CFG.module.basePrice);      // Einsatz
        const sh = shelfUnit();
        if(sh && it.shelves > 0) add(sh.variantId, sh.name, sh.price, it.shelves); // Einlegeboden in der Menge n
      }
      const h = CFG.handles[effHandle(c)];
      if(h.kind!=='none') add(h.variantId, h.title, h.price);   // „ohne Griff" ist kein Produkt
    });
    const g = grid();
    const bundleId = 'KX-' + Date.now().toString(36).toUpperCase();
    const t = totals();
    // Der Klartext steht EINMAL in den speziellen Bestellanweisungen (Cart Note),
    // nicht an jeder Position – dort verwirrt er nur. An den Positionen bleiben
    // zwei versteckte Felder (Unterstrich): die Nummer, die sie zusammenhält,
    // und der Link zur Konfiguration. Beides sieht nur ABOUT SHELVES.
    const props = { _bundle_id: bundleId, _kallax_link: shareUrl() };
    const items = [...agg.values()].map(e=>({ id:e.id, quantity:e.quantity, properties:{...props} }));

    const innenTxt = it => it.module
      ? 'Einsatz ' + (it.shelves===0 ? 'ohne Boden' : it.shelves===1 ? 'mit 1 Boden' : 'mit ' + it.shelves + ' Böden')
      : 'ohne unseren Einsatz (IKEA*-Einsatz)';
    const zeilen = state.cubes.map((c,i)=>{
      if(!c.door) return null;
      const h = CFG.handles[effHandle(c)];
      return `Fach ${i+1}: ${CFG.doors[c.door].name} · ${innenTxt(eff(c))} · ${h.kind==='none' ? 'ohne Griff' : h.label}`;
    }).filter(Boolean);
    const offen = state.cubes.filter(c=>!c.door).length;
    const note = [
      `KALLAX ${g.label} · ${CFG.korpus[state.korpus].name} · Konfiguration ${bundleId}`,
      ...zeilen,
      offen ? `${offen} ${offen===1 ? 'Fach bleibt' : 'Fächer bleiben'} offen.` : null,
      t.tuerOnly ? `Achtung: ${t.tuerOnly} Tür(en) ohne unseren Einsatz – dafür ist ein IKEA* KALLAX* Einsatz nötig.` : null,
      shareUrl()
    ].filter(Boolean).join('\n');

    return { items, note, agg:[...agg.values()], total:t.sum };
  }
  // Echter Warenkorb. Zwei Regeln:
  // 1. Der Konfigurator legt AUSSCHLIESSLICH seine eigenen Positionen in den Korb -
  //    nichts aus dem Produktformular oben, keine Pflichtartikel einer Optionen-App.
  // 2. Was vorher im Korb lag, bleibt unangetastet (/cart/add haengt nur an).
  // Liquid liefert /cart/add; die AJAX-API liegt auf .js.
  const ajaxUrl = u => /\.js($|\?)/.test(u) ? u : u.replace(/\/$/, '') + '.js';

  // Optionen-Apps (EasyFlow & Co.) ueberschreiben window.fetch/XMLHttpRequest und
  // haengen an JEDES /cart/add die Pflichtartikel des Produkts an, auf dessen Seite
  // man gerade steht. Unsere Anfrage laeuft deshalb ueber ein unberuehrtes fetch aus
  // einem leeren iframe: gleiche Domain, gleicher Warenkorb, aber ohne fremde Patches.
  function cleanNet(){
    try{
      const fr = document.createElement('iframe');
      fr.setAttribute('aria-hidden', 'true');
      fr.setAttribute('tabindex', '-1');
      fr.style.cssText = 'position:absolute;left:-9999px;top:0;width:0;height:0;border:0';
      document.body.appendChild(fr);
      const w = fr.contentWindow;
      if(w && typeof w.fetch === 'function'){
        return { call: w.fetch.bind(w), done(){ try{ fr.remove(); }catch(e){} }, rein: true };
      }
      fr.remove();
    }catch(e){}
    return { call: window.fetch.bind(window), done(){}, rein: false };
  }

  async function submitCart(){
    const cart = buildCart();
    const bad = cart.items.filter(i => !/^\d+$/.test(String(i.id)));
    if(bad.length){
      toast('Im Theme fehlt eine Produktverknüpfung – bitte in den Section-Einstellungen prüfen.');
      track('cart_blocked', {fehlend: bad.length});
      return;
    }
    const btn = $('atc'), label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
    const net = cleanNet();
    const fertig = () => { net.done(); btn.disabled = false; btn.textContent = label; };
    try{
      // Nur der Cart-Drawer kann mehrere Positionen auf einmal rendern. Dawns
      // Cart-Notification sucht die neue Zeile ueber parsedState.key - den gibt
      // es bei einem Add mit mehreren Items nicht, sie laeuft dann auf null.
      // Deshalb: Drawer ja, Notification nein - sonst auf /cart, wo der Kunde
      // ohnehin die ganze Konfiguration sieht.
      const drawer = document.querySelector('cart-drawer');
      const body = {items: cart.items};
      if(drawer && typeof drawer.getSectionsToRender === 'function'){
        body.sections = drawer.getSectionsToRender().map(s => s.id);
        body.sections_url = window.location.pathname;
      }
      const res = await net.call(ajaxUrl(CFG.routes.cartAdd), {
        method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
        body: JSON.stringify(body)
      });
      const json = await res.json();
      if(json.status || json.errors) throw new Error(json.description || json.message || 'Warenkorb-Fehler');
      track('add_to_cart', {positionen: cart.items.length, eigenesFetch: net.rein});
      // Klartext EINMAL in die speziellen Bestellanweisungen, an eine vorhandene
      // Notiz angehaengt statt sie zu ueberschreiben (zweites Regal, fremder Text).
      // Schlaegt das fehl, ist es kein Drama: die Artikel liegen schon im Korb.
      try{
        const alt = await net.call(ajaxUrl(CFG.routes.cart), {headers:{'Accept':'application/json'}})
          .then(r => r.json()).then(c => String(c.note || '').trim());
        await net.call(ajaxUrl(CFG.routes.cartUpdate), {
          method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({note: alt ? alt + '\n\n' + cart.note : cart.note})
        });
      }catch(err){ track('cart_note_failed', {meldung: (err && err.message) || 'unbekannt'}); }
      // Ab hier liegen die Artikel im Warenkorb. Was jetzt schiefgeht, ist reine
      // Darstellung und darf nie als Fehler erscheinen.
      if(drawer && typeof drawer.renderContents === 'function'){
        try{
          if(drawer.classList) drawer.classList.remove('is-empty');
          drawer.renderContents(json);
          fertig();
          return;
        }catch(err){ track('cart_render_fallback', {meldung: (err && err.message) || 'unbekannt'}); }
      }
      net.done();
      window.location.href = CFG.routes.cart;
      return;
    }catch(e){
      toast('Konnte nicht in den Warenkorb gelegt werden: ' + ((e && e.message) || 'Fehler'));
      track('cart_error', {meldung: (e && e.message) || 'unbekannt'});
    }
    fertig();
  }

  /* ---------- Events ---------- */
  function resizeCubes(){
    const old = state.cubes.slice(), n = grid().cols*grid().rows;
    state.cubes = Array.from({length:n}, (_,i)=> old[i] ? {...old[i]} : emptyCube());
  }
  $('gridRow').addEventListener('click', e=>{
    const b = e.target.closest('[data-grid]'); if(!b) return;
    state.touched.size = true;
    if(b.dataset.grid!==state.size){ state.size = b.dataset.grid; resizeCubes(); track('size_changed'); }
    maybeCollapse(); renderAll();
  });
  $('orientRow').addEventListener('click', e=>{ const b=e.target.closest('[data-orient]'); if(!b) return; state.orient=b.dataset.orient; resizeCubes(); renderAll(); });
  $('korpusRow').addEventListener('click', e=>{ const b=e.target.closest('[data-korpus]'); if(!b) return; state.korpus=b.dataset.korpus; state.touched.korpus=true; track('korpus_changed'); maybeCollapse(); renderAll(); });
  $('summary').addEventListener('click', ()=>{ state.setupOpen=true; state.touched={size:false,korpus:false}; renderSetup(); });
  $('openToggle').addEventListener('click', ()=>{ state.open=!state.open; track('doors_toggled', {offen:state.open}); renderAll(); });
  $('sceneRow').addEventListener('click', e=>{ const b=e.target.closest('[data-scene]'); if(!b) return; state.scene=b.dataset.scene; renderAll(); });

  // Malen per Tipp oder Wischen (pointer capture; vertikales Wischen scrollt weiter)
  let stroke = null;
  const svgEl = $('svg');
  function hitAt(x,y){ const el = document.elementFromPoint(x,y); return el && el.classList && el.classList.contains('kx-hit') ? parseInt(el.dataset.i,10) : -1; }
  svgEl.addEventListener('pointerdown', e=>{
    const i = hitAt(e.clientX, e.clientY); if(i<0) return;
    snapshot(); stroke = { painted:new Set([i]), changed:false };
    stroke.changed = paint([i]) || stroke.changed;
    try{ svgEl.setPointerCapture(e.pointerId); }catch(err){}
    $('hint').style.opacity='0';
  });
  svgEl.addEventListener('pointermove', e=>{
    if(!stroke) return;
    const i = hitAt(e.clientX, e.clientY); if(i<0 || stroke.painted.has(i)) return;
    stroke.painted.add(i); stroke.changed = paint([i]) || stroke.changed;
  });
  function endStroke(){
    if(!stroke) return;
    if(!stroke.changed) state.history.pop();
    else track(state.layer==='door' ? 'door_painted' : 'exception_painted', {mode: stroke.painted.size>1 ? 'drag':'tap', felder: stroke.painted.size, layer: state.layer});
    stroke=null; renderPanel();
  }
  svgEl.addEventListener('pointerup', endStroke);
  svgEl.addEventListener('pointercancel', endStroke);
  window.addEventListener('pointerup', endStroke);

  $('doorSwatches').addEventListener('click', e=>{
    const b=e.target.closest('[data-door]'); if(!b) return;
    state.brushDoor = b.dataset.door==='none' ? null : b.dataset.door;
    backToDoorLayer(); track('door_brush_changed', {tuer: state.brushDoor || 'keine'});
    collapseSetup(); renderAll();
  });

  // Umfang-Schalter: Alle ↔ Einzeln
  $('intScope').addEventListener('click', e=>{ const b=e.target.closest('[data-iscope]'); if(!b) return; setScope('interior', b.dataset.iscope); });
  $('hndScope').addEventListener('click', e=>{ const b=e.target.closest('[data-hscope]'); if(!b) return; setScope('handle', b.dataset.hscope); });

  // Innenleben-Palette: im Einzeln-Modus nur Pinsel, im Alle-Modus Standard für alle (setzt Ausnahmen zurück)
  let noteTimer = null;
  $('stdRow').addEventListener('click', e=>{
    const b=e.target.closest('[data-std]'); if(!b) return;
    const val = parseInterior(b.dataset.std); if(!val) return;
    if(state.interiorScope==='single'){ state.excBrush = val; renderPanel(); return; }
    const exc = excIntCount();
    if(exc){ snapshot(); state.cubes.forEach(c=>{ c.interior=null; }); }
    state.interior = val;
    track('interior_changed', {code:b.dataset.std, ausnahmen_zurueckgesetzt:exc});
    collapseSetup(); renderAll();
    const note = $('stdNote');
    if(exc){
      note.textContent = `${exc} ${exc===1?'Ausnahme':'Ausnahmen'} zurückgesetzt – der Standard gilt wieder für alle Fächer.`;
      note.hidden = false; clearTimeout(noteTimer); noteTimer = setTimeout(()=>{ note.hidden = true; }, 8000);
    } else { note.hidden = true; }
  });
  // Griffe: gleiches Prinzip
  let hnoteTimer = null;
  $('handleRow').addEventListener('click', e=>{
    const b=e.target.closest('[data-handle]'); if(!b) return;
    const key = b.dataset.handle; if(!CFG.handles[key]) return;
    if(state.handleScope==='single'){ state.excHandle = key; renderPanel(); return; }
    const exc = excHndCount();
    if(exc){ snapshot(); state.cubes.forEach(c=>{ c.handle=null; }); }
    state.handle = key;
    track('handle_changed', {griff:key, ausnahmen_zurueckgesetzt:exc});
    collapseSetup(); renderAll();
    const note = $('handleNote');
    if(exc){ note.textContent = `${exc} ${exc===1?'Ausnahme':'Ausnahmen'} zurückgesetzt – der Griff gilt wieder für alle Türen.`; note.hidden=false; clearTimeout(hnoteTimer); hnoteTimer=setTimeout(()=>{ note.hidden=true; }, 8000); } else note.hidden=true;
  });
  $('hexReset').addEventListener('click', ()=>{ snapshot(); state.cubes.forEach(c=>{ c.handle=null; }); track('exceptions_reset',{layer:'handle'}); renderAll(); });
  $('excReset').addEventListener('click', ()=>{ snapshot(); state.cubes.forEach(c=>{ c.interior=null; }); track('exceptions_reset',{layer:'interior'}); renderAll(); });
  const onKeyDown = e=>{
    if((e.ctrlKey||e.metaKey) && e.key==='z'){ e.preventDefault(); undo(); }
    if(e.key==='Escape') $('shotModal').classList.remove('kx-on');
  };
  if(window.__kxCleanup) window.__kxCleanup();
  document.addEventListener('keydown', onKeyDown);
  window.__kxCleanup = function(){
    document.removeEventListener('keydown', onKeyDown);
    window.removeEventListener('pointerup', endStroke);
  };

  $('atc').addEventListener('click', submitCart);

  // Teilen, Bild, Wiederkehr
  $('shareBtn').addEventListener('click', shareConfig);
  $('shotBtn').addEventListener('click', exportShot);
  $('shotClose').addEventListener('click', ()=>$('shotModal').classList.remove('kx-on'));
  $('shotModal').addEventListener('click', e=>{ if(e.target===$('shotModal')) $('shotModal').classList.remove('kx-on'); });
  $('shotSave').addEventListener('click', saveShot);
  $('shotShare').addEventListener('click', shareShot);
  $('restoreYes').addEventListener('click', ()=>{
    if(!pendingRestore) return;
    const r = decode('#'+pendingRestore.h);
    $('restore').hidden = true;
    if(r.ok){ track('config_restored_from_storage'); if(r.warn.bad) showHashWarn(); renderAll(); }
    else toast('Die gespeicherte Konfiguration ließ sich nicht lesen');
    pendingRestore = null;
  });
  $('restoreNo').addEventListener('click', ()=>{ $('restore').hidden = true; pendingRestore = null; track('config_restore_dismissed'); });

  function showHashWarn(){
    $('hashWarn').textContent = 'Ein Teil des Links konnten wir nicht lesen – für diese Fächer gilt der Standard. Prüf die Konfiguration kurz nach.';
    $('hashWarn').hidden = false;
    track('config_link_partial');
  }

  /* ---------- Start ---------- */
  const start = decode(location.hash);
  if(start.ok){
    track('config_restored_from_link');
    if(start.warn.bad) showHashWarn();
  } else {
    seed();
    offerRestore();
  }
  renderAll();
  track('configurator_open', {quelle: start.ok ? 'link' : (pendingRestore ? 'storage_angeboten' : 'neu')});
  setTimeout(()=>{ $('hint').style.opacity='0'; }, 6000);

  // Selbsttest für den längsten Fall (5×5, jede Zelle abweichend) – Zielgröße < 500 Zeichen
  window.__kallaxHashTest = CFG.debugTracking ? function(){
    const keep = JSON.stringify({size:state.size, orient:state.orient, cubes:state.cubes, interior:state.interior, handle:state.handle, korpus:state.korpus, scene:state.scene});
    state.size='5x5'; state.korpus='schwarzbraun'; state.scene='office'; state.handle='knopf'; state.interior={module:false,shelves:1};
    const doors=['P','L','R'], ints=[null,{module:false,shelves:1},{module:true,shelves:0},{module:true,shelves:2}], hs=[null,'ohne','weiss','schwarz','spiegel','knopf'];
    state.cubes = Array.from({length:25},(_,i)=>({door:doors[i%3], interior:ints[i%4]?{...ints[i%4]}:null, handle:hs[i%6]}));
    const h = '#'+encode(), url = location.href.split('#')[0]+h;
    const back = decode(h);
    const res = {hashLen:h.length, urlLen:url.length, hash:h, ok:back.ok && !back.warn.bad, cubes:state.cubes.length};
    const k = JSON.parse(keep); Object.assign(state, {size:k.size, orient:k.orient, cubes:k.cubes, interior:k.interior, handle:k.handle, korpus:k.korpus, scene:k.scene});
    renderAll(); return res;
  } : undefined;
};

/* Start: einmal beim Laden, und erneut, wenn der Theme-Editor die Section neu rendert. */
(function boot(){
  const start = function(){ if(document.getElementById('kx-data')) window.KallaxKonfigurator(); };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function(e){
    if(e.target && e.target.querySelector && e.target.querySelector('#kx-data')) window.KallaxKonfigurator();
  });
})();
